import React from 'react';

import WmsButton from './../../../components/WmsButton/WmsButton.jsx';
import WmsDropdown from './../../../components/WmsDropdown/WmsDropdown.jsx';
import WmsModel from './../../../components/WmsModel/WmsModel.jsx';
import WmsCollapse from './../../../components/WmsCollapse/WmsCollapse.jsx';
import WmsCheckBox from './../../../components/WmsCheckBox/WmsCheckBox.jsx';
import WmsDateTimePicker from './../../../components/WmsDateTimePicker/WmsDateTimePicker.jsx';
import { FedexEulaAgreementComponent } from './fedex-eula-agreement.component.jsx';
import { FedexEditComponent } from './fedex-edit.component.jsx';
import { UpsEditComponent } from './ups-edit.component.jsx';
import { UpsEulaAgreementComponent } from './ups-eula-agreement.component.jsx';
import WmsInput from './../../../components/WmsInput/WmsInput.jsx';
import WmsRadio from './../../../components/WmsRadio/WmsRadio.tsx';
import axios from "axios";

//services
import * as GlobalService from './../../../global_services';
import * as carrierService from './../../small-parcel-settings.services.jsx';
import { EndiciaAccountInfoComponent } from './endicia-account-info.component.jsx';
import { DHLeCommerceAccountInfoComponent } from './dhl-eCommerce-account-info.component.jsx';
import { DHLExpressAccountInfoComponent } from './dhl-express-account-info.component.jsx';
import { AustraliaPostAccountInfoComponent } from './australia-post-account-info.component.jsx';
import { StampsAccountInfoComponent } from './stamps-account-info.component.jsx';
import { APCAccountInfoComponent } from './apc-account-info.component.jsx';
import { FirstMileInfoComponent } from './first-mile-info.component.jsx';
import { GlobegisticsInfoComponent } from './globegistics-info.component.jsx';
import { RrDonnelleyInfoComponent } from './rrDonnelley-info.component.jsx';
import { CanadaPostComponent } from './canada-post.component.jsx';
import { OnTraceComponent } from './on-trac.component.jsx';
import { SekoComponent } from './seko.component.jsx';
import { AmazonComponent } from './amazon.component.jsx';
import { CanparAccountInfoComponent } from './canpar-account-info.component.jsx';
import { PurolatorAccountInfoComponent } from './purolator-account-info.component.jsx';
import { DHLExpressAUAccountInfoComponent } from './dhl-express-au-account-info.component.jsx';
import { USPSBukuShipAccountInfoComponent } from './usps-bukuship-account-info.component.jsx';
import { PitneyBowesStandardInfoComponent } from './pitney-bowes-standard-info-component.jsx';
import { LandmarkAccountInfoComponent } from './landmark-account-info.component.jsx';
import { StallionAccountInfoComponent } from './stallion-account-info.component.jsx';
import { ParcllAccountInfoComponent } from './parcll-account-info.component.jsx';
import { EpostGlobalAccountInfoComponent } from './epostGlobal-account-info.component.jsx';
import { PitneyBowesExpeditedInfoComponent } from './pitney-bowes-expedited-info-component.jsx';
import { PitneyBowesCrossBorderInfoComponent } from './pitney-bowes-cross-border-info-component.tsx';
import { PassportInfoComponent } from './passport-info.component.tsx';
import { SendleInfoComponent } from './sendle-info.component.tsx';
import { TuskInfoComponent } from './tusk-info.component.tsx';
import { FlexportInfoComponent } from './flexport-info.component.tsx';
import { LasershipInfoComponent } from './lasership-info.component.tsx';
import { UpsmiAccountInfoComponent } from './upsmi-account-info.component.jsx';
import FedExSmartPostAccountInfoComponent from './fedex-smartpost-info-component';
import UpsSurePostAccountInfoComponent from './ups-surepost-account-info.component';
import { CarriersEditComponent } from './carriers-edit.component.tsx';
import style from './new-carrier-connection.scss';

export class NewCarrierConnectionModel extends React.Component {

    constructor(props) {

        super(props);

        this.translate = window.translate;
        this.$rootScope = window;
        this.selector = this.props.selector + "Carrier";
        this.rights = GlobalService.GetRights();
        this.optionsCountry = GlobalService.GetCountries();
        this.customerOptions = GlobalService.getCustomerList();
        this.facilityOption = GlobalService.getFacilityList(false);
        this.isEnableProvider = this.rights.hasOwnProperty('Shipping.SmallParcelEnabled') && this.rights['Integrations.SmallParcelPartner'] == 'ParcelApi';
        this.carrierElementClass = this.isEnableProvider ? "new-connection-four-elements" : "new-connection-three-elements";

        this.selectedProviderObj = [];
        this.timer = 0;
        this.countDown = this.countDown.bind(this);
        this.selectedCustomerName = this.props.sharedSelectedCustomer.name;
        this.state = {
            selectedContentType: '',
            selectedFacilityIndex: '',
            selectedCustomerIndex: '',
            selectedCarrierIndex: '',
            selectedProviderIndex: '',
            selectedCarrier: '',
            carrierConnectionBtnLoader: false,
            currentStep: 1,
            totalSteps: 0,
            currentCarrierImgUrl: '',
            currentLoginLabel: 'Login',
            carrierOptions: [],
            providerOptions: [],
            pickupTypeOptions: [],
            smartPostHubOptions: [],
            smartPostEndorsementOptions: [],
            mailInnovationsEndorsementOptions: [],
            optionsState: [],
            currentCarrierObj: {},
            isOpenPitneyBowesModel: false,
            pitneyBowesUsername: '',
            pitneyBowesPassword: '',
            pitneyBowesErrorMessage: '',
            pitneyBowesCrossBorderDisabledStatus: true,
            isAuthUrl: false,
            authUrl: "",
            upsAuthFlowCurrentStep: 0,
            isHaveUpsAuthorization: null,
            showExpireLinkTimer: false,
            time: {},
            seconds: 300, // Reminder to saw for 5 minutes
            showExpiredLinkMsg: false,
            checkCarrierConnectionBtnLoader: false,
            isCarrierConnectionWorking: "None",
            isResetLinkCalling: false,
            isFromResetLink: false,
            isAuthReset: false
        };
    }
    componentDidMount() {

        this.getCarrierOptions();
        this.createContainerElement();
        if (this.props.sharedCarrierConnectionFlow == 'edit') {

            kendo.ui.progress($('#newCarrierConnection'), true);
            carrierService.getCarrierDetail(this.props.sharedSelectedCarrierAccountData.ShipEngineId, this.props.sharedSelectedCustomer.id).then((response) => {

                if (this.isEnableProvider) {
                    response.data.Provider = this.props.sharedSelectedCarrierAccountData.Provider;
                }
                this.setState({
                    currentCarrierObj: response.data
                });
                this.setCarrierOptions(response.data.CarrierName);

            }).finally(() => {
                kendo.ui.progress($('#newCarrierConnection'), false);
            });

        }
    }
    getCarrierOptions = () => {
        var carrierOptions = this.props.sharedShipEngineCarrier;
        this.setState({
            carrierOptions: carrierOptions
        });
    }
    handleChangeEvent = (e) => {
        let name = e.target.name;
        let tmpCurrentCarrierObj = Object.assign({}, this.state.currentCarrierObj);
        if (e.target.type == 'checkbox') {
            this.setState({ [name]: !this.state[name] });
        } else {
            this.setState({ [name]: e.target.value });
        }

        if (name == 'selectedContentType' && e.target.value == 'Warehouse Account') {
            tmpCurrentCarrierObj.IncludeShippingCost = true;
        }

        if (name == 'selectedContentType' && (!e.target.value || e.target.value == 'Customer Account')) {
            tmpCurrentCarrierObj.IncludeShippingCost = false;
        }

        if (name == 'selectedCustomerIndex' && this.state.selectedContentType == 'Customer Account' && e.target.value) {
            let tmpCustomerObj = this.customerOptions[e.target.value];
            this.selectedCustomerName = tmpCustomerObj.name;
        }

        if ((name == 'selectedContentType' && (!e.target.value || this.state.selectedContentType != 'Customer Account')) || (name == 'selectedCustomerIndex' && !e.target.value)) {
            this.selectedCustomerName = this.props.sharedSelectedCustomer.name;
        }

        if (name == 'selectedCarrierIndex') {
            if (e.target.value) {
                let tmpSelectedCarrier = this.state.carrierOptions[e.target.value].Carrier;

                this.setCarrierOptions(tmpSelectedCarrier);

                // Check If Flexport Carrier Then Select Direct To Carrier Provider
                if(tmpSelectedCarrier === 'Flexport') {
                    this.setState({ selectedProviderIndex: 'flexport' });
                } else {
                    this.setState({ selectedProviderIndex: '' });
                }

                this.setState({ currentCarrierObj: {} });
            } else {
                this.setState({
                    selectedProviderIndex: '',
                    providerOptions: []
                });
            }
        }
        this.setState({ currentCarrierObj: tmpCurrentCarrierObj });
    }
    setCarrierOptions = async (tmpSelectedCarrier) => {


        let totalSteps = 2;
        let currentStep = 1;
        let currentCarrierImgUrl = '3PL_Logo_Orange.png';
        let currentLoginLabel = 'Login';
        let providerOptions = [];
        if (this.isEnableProvider && tmpSelectedCarrier != "USPS" && tmpSelectedCarrier != "Landmark" && tmpSelectedCarrier != "Cirro E-Commerce" && tmpSelectedCarrier != "Pitney Bowes Cross-Border" && tmpSelectedCarrier != "Stallion Express" && tmpSelectedCarrier != "UPS Mail Innovations" && tmpSelectedCarrier != "FedEx SmartPost" && tmpSelectedCarrier != "UPS SurePost" && tmpSelectedCarrier != "Flexport") {
            providerOptions = [
                {
                    DisplayName: "ShipEngine",
                    Code: "shipEngine"
                }
            ];
        }

        if (tmpSelectedCarrier == 'Endicia') {
            totalSteps = 2;
            currentCarrierImgUrl = 'endicia-logo.png';
            currentLoginLabel = 'Endicia Account';
        } else if (tmpSelectedCarrier == 'FedEx') {
            if (this.isEnableProvider && !this.rights.hasOwnProperty("UxPrototypingDirectivesHidePitneyBuku")) {
                providerOptions.push({
                    DisplayName: "BUKU Ship",
                    Code: "bukuShip"
                }/*, {
                    DisplayName: "Pitney Bowes",
                    Code: "pitneyBowes"
                }*/);
            }
            totalSteps = 3;
            currentCarrierImgUrl = 'FedEx-logo.png';
        } else if (tmpSelectedCarrier == 'PitneyBowesStd') {
            providerOptions = [
                {
                    DisplayName: "Pitney Bowes",
                    Code: "pitneyBowes"
                }
            ];
            totalSteps = 2;
            currentCarrierImgUrl = 'pitney-bowes-standard-logo.png';
        } else if (tmpSelectedCarrier == 'Stamps.com') {
            totalSteps = 2;
            currentCarrierImgUrl = 'Stamps.com-logo.png';
            currentLoginLabel = 'Stamps Account';
        } else if (tmpSelectedCarrier == 'APC') {
            totalSteps = 2;
            currentCarrierImgUrl = 'APC-logo.png';
        } else if (tmpSelectedCarrier == 'USPS') {
            if (this.isEnableProvider) {
                if (!this.rights.hasOwnProperty('UxPrototypingDirectivesHidePitneyBuku')) {
                    providerOptions = [
                        {
                            DisplayName: "Pitney Bowes Expedited",
                            Code: "pitneyBowes"
                        }
                    ];
                }
                if (!this.rights.hasOwnProperty('UxPrototypingDirectivesHidePitneyBuku') && !this.rights.hasOwnProperty("UxPrototypingDirectivesHideUSPSProviders")) {
                    providerOptions.push(
                        {
                            DisplayName: "BUKU Ship",
                            Code: "bukuShip"
                        }
                    );
                }
                if (!this.rights.hasOwnProperty("UxPrototypingDirectivesHideUSPSProviders")) {
                    providerOptions.push(
                        {
                            DisplayName: "Endicia",
                            Code: "Endicia"
                        },
                        {
                            DisplayName: "Stamps.com",
                            Code: "Stamps.com"
                        }
                    );
                }
            }
        } else if (tmpSelectedCarrier == "UPS") {
            if (this.isEnableProvider && !this.rights.hasOwnProperty("UxPrototypingDirectivesHidePitneyBuku")) {
                providerOptions.push({
                    DisplayName: "BUKU Ship",
                    Code: "bukuShip"
                });
            }
            totalSteps = 3;
            currentCarrierImgUrl = 'UPS-logo.png';
        } else if (tmpSelectedCarrier == 'DHL eCommerce') {
            if (this.isEnableProvider && !this.rights.hasOwnProperty("UxPrototypingDirectivesHidePitneyBuku")) {
                providerOptions.push({
                    DisplayName: "BUKU Ship",
                    Code: "bukuShip"
                });
            }
            totalSteps = 2;
            currentCarrierImgUrl = 'dhl-ecommerce.png';
        } else if (tmpSelectedCarrier == 'DHL Express') {
            if (this.isEnableProvider) {
                providerOptions.push({
                    DisplayName: "BUKU Ship",
                    Code: "bukuShip"
                });
            }
            totalSteps = 2;
            currentCarrierImgUrl = 'dhl-express.png';
        } else if (tmpSelectedCarrier == 'Australia Post') {
            totalSteps = 2;
            currentCarrierImgUrl = 'australia-post.png';
        } else if (tmpSelectedCarrier == 'Purolator') {
            totalSteps = 2;
            currentCarrierImgUrl = 'purolator-seeklogo.com.png';
        } else if (tmpSelectedCarrier == 'DHL Express Australia') {
            totalSteps = 2;
            currentCarrierImgUrl = 'DHLExpressAU.png';
        } else if (tmpSelectedCarrier == 'Firstmile') {
            if (this.isEnableProvider) {
                providerOptions.push({
                    DisplayName: "BUKU Ship",
                    Code: "bukuShip"
                });
            }
            totalSteps = 2;
            currentCarrierImgUrl = 'First Mile.png';
        } else if (tmpSelectedCarrier == 'Globegistics') {
            totalSteps = 2;
            currentCarrierImgUrl = 'Globegistics.png';
        } else if (tmpSelectedCarrier == 'RR Donnelley') {
            totalSteps = 2;
            currentCarrierImgUrl = 'rrDonnelley.png';
        } else if (tmpSelectedCarrier == 'Canada Post') {
            totalSteps = 2;
            currentCarrierImgUrl = 'canada-post-logo.jpg';
        } else if (tmpSelectedCarrier == 'OnTrac') {
            totalSteps = 2;
            currentCarrierImgUrl = 'ontrac.png';
        } else if (tmpSelectedCarrier == 'SEKO') {
            totalSteps = 2;
            currentCarrierImgUrl = 'seko.png';
        } else if (tmpSelectedCarrier == 'Amazon Buy') {
            totalSteps = 2;
            currentCarrierImgUrl = 'amazon.png';
        } else if (tmpSelectedCarrier == 'Canpar') {
            totalSteps = 2;
            currentCarrierImgUrl = 'canpar.png';
        } else if (tmpSelectedCarrier == 'ePost Global' || tmpSelectedCarrier == 'Landmark' || tmpSelectedCarrier == 'Cirro E-Commerce' || tmpSelectedCarrier == 'Stallion Express' || tmpSelectedCarrier == 'UPS Mail Innovations' || tmpSelectedCarrier == 'FedEx SmartPost' || tmpSelectedCarrier == 'UPS SurePost') {
            totalSteps = 2;
            if (this.isEnableProvider) {
                providerOptions.push({
                    DisplayName: "BUKU Ship",
                    Code: "bukuShip"
                });
            }
            if(tmpSelectedCarrier == 'Cirro E-Commerce') {
                currentCarrierImgUrl = 'cirro-ecommerce.png';
            }
            if(tmpSelectedCarrier == 'ePost Global') {
                currentCarrierImgUrl = 'ePost-global.png';
            }
            if(tmpSelectedCarrier == 'Landmark') {
                currentCarrierImgUrl = 'landmark.png';
            }
            if(tmpSelectedCarrier == 'Stallion Express') {
                currentCarrierImgUrl = 'StallionExpressLogo.png';
            }
            if(tmpSelectedCarrier == 'UPS Mail Innovations') {
                currentCarrierImgUrl = 'UPS-logo.png';
            }
            if(tmpSelectedCarrier == 'FedEx SmartPost') {
                currentCarrierImgUrl = 'FedEx-logo.png';
            }
            if(tmpSelectedCarrier == 'UPS SurePost') {
                currentCarrierImgUrl = 'UPS-logo.png';
            }
        } else if (tmpSelectedCarrier == 'Pitney Bowes Cross-Border') {
            totalSteps = 2;
            providerOptions = [
                {
                    DisplayName: "Pitney Bowes",
                    Code: "pitneyBowes"
                }
            ];
            currentCarrierImgUrl = 'pitney-bowes-standard-logo.png';
        } else if (tmpSelectedCarrier === 'Passport') {
            totalSteps = 2;
            currentCarrierImgUrl = 'passport-shipping-logo.png';
        } else if (tmpSelectedCarrier === 'Sendle') {
            totalSteps = 2;
            currentCarrierImgUrl = 'sendle-logo.png';
        } else if (tmpSelectedCarrier === 'Tusk Logistics') {
            totalSteps = 2;
            currentCarrierImgUrl = 'tusk-logo.png';
        } else if (tmpSelectedCarrier === 'Flexport') {
            totalSteps = 2;
            currentCarrierImgUrl = 'flexport.png';
            providerOptions = [
                {
                    DisplayName: "Flexport",
                    Code: "flexport"
                }
            ];
        } else if (tmpSelectedCarrier === 'Lasership') {
            totalSteps = 2;
            currentCarrierImgUrl = 'lasership-logo.png';
        } else if (tmpSelectedCarrier === 'PitneyBowesExp') {
            totalSteps = 2;
            currentCarrierImgUrl = 'pitney-bowes-standard-logo.png';
        } else if (tmpSelectedCarrier === 'Buku') {
            totalSteps = 2;
            currentCarrierImgUrl = 'buku-ship.png';
        }

        let optionsForSettings = GlobalService.getDropdownOptionsForSettings(tmpSelectedCarrier);

        this.setState({
            currentCarrierImgUrl: currentCarrierImgUrl,
            totalSteps: totalSteps,
            currentLoginLabel: currentLoginLabel,
            selectedCarrier: tmpSelectedCarrier,
            pickupTypeOptions: optionsForSettings.pickupType,
            smartPostHubOptions: optionsForSettings.smartPostHub,
            smartPostEndorsementOptions: optionsForSettings.smartPostEndorsement,
            mailInnovationsEndorsementOptions: optionsForSettings.mailInnovationsEndorsement,
            currentStep: currentStep,
            providerOptions: providerOptions
        });
    }

    handleCarrierObjChange = (e) => {

        let tmpCurrentCarrierObj = Object.assign({}, this.state.currentCarrierObj);
        let tmpName = e.target.name;

        if (e.target.type == 'checkbox') {
            tmpCurrentCarrierObj[tmpName] = !tmpCurrentCarrierObj[tmpName];
        } else {
            tmpCurrentCarrierObj[tmpName] = e.target.value;
        }

        if (this.state.selectedCarrier === "Pitney Bowes Cross-Border") {
            if (tmpName === "shipmentType") {
                tmpCurrentCarrierObj["cbdsDeliverySolution"] = "";
                tmpCurrentCarrierObj["clientFacilityId"] = undefined;
                tmpCurrentCarrierObj["cbdsHub"] = "";
                tmpCurrentCarrierObj["clientId"] = undefined;
            }
            this.setState({ pitneyBowesCrossBorderDisabledStatus: this.handlePitneyBowesDisabledStatus(tmpCurrentCarrierObj) });
        }
        if (tmpName == 'CountryCode') {
            this.setState({ optionsState: GlobalService.GetRegions(e.target.value) });
        }
        this.setState({ currentCarrierObj: tmpCurrentCarrierObj });
    }

    handlePitneyBowesDisabledStatus = (currentCarrierObject) => {
        let isMissingSomeRequiredProperty = true;
        const { shipmentType, cbdsDeliverySolution, cbdsHub, clientId, nickname, clientFacilityId } = currentCarrierObject;
        if (!shipmentType || !nickname) return isMissingSomeRequiredProperty;

        if (["DOMESTIC", "RETURN"].includes(currentCarrierObject?.shipmentType)) {
            isMissingSomeRequiredProperty = !(cbdsDeliverySolution)
        }
        if (currentCarrierObject?.shipmentType === "OUTBOUND") {
            const isPitneyStandardDeliverySolution = cbdsDeliverySolution === "PICKUP_STANDARDLABEL";
            const isMissingRequiredPropertiesForPbStandard = !(cbdsDeliverySolution && cbdsHub && clientId && clientFacilityId);
            const isMissingRequiredPropertiesForPbOutbound = !(cbdsDeliverySolution && cbdsHub);

            isMissingSomeRequiredProperty = isPitneyStandardDeliverySolution ? isMissingRequiredPropertiesForPbStandard : isMissingRequiredPropertiesForPbOutbound
        }
        return isMissingSomeRequiredProperty
    }

    movePreviousStep = () => {
        if (this.state.isAuthUrl && this.state.upsAuthFlowCurrentStep > 0) {
            let tmpAuthFlowStep = this.state.upsAuthFlowCurrentStep - 1

            // Reset carrier connection auth flow when user back fom first step
            let tmpIsAuthUrl = this.state.isAuthUrl
            if (tmpAuthFlowStep == 0) {
                tmpIsAuthUrl = false
            }
            this.setState({
                upsAuthFlowCurrentStep: tmpAuthFlowStep,
                isAuthUrl: tmpIsAuthUrl
            });
        } else {
            let prvStep = this.state.currentStep - 1;
            if (this.state.isOpenPitneyBowesModel) {
                prvStep = this.state.currentStep;
            }
            this.setState({
                currentStep: prvStep,
                isOpenPitneyBowesModel: false,
                isAuthUrl: false
            });
        }
    }

    moveNextStep = async() => {
        var isOpenPitneyBowesModel = false;
        let nxtStep = this.state.currentStep + 1;

        let selectedProviderIndex = this.state.selectedProviderIndex;
        this.selectedProviderObj = _.find(this.state.providerOptions, function (o) {
            return o.Code == selectedProviderIndex
        });
        let isAlreadyLoggedIn = false;
        if (
            !this.state.isOpenPitneyBowesModel &&
            this.state.currentStep == 1 &&
            (
                selectedProviderIndex == "pitneyBowes" || selectedProviderIndex == "bukuShip"
            )
        ) {
            this.setState({ carrierConnectionBtnLoader: true });
            await carrierService.getProviderDetail(selectedProviderIndex).then((response) => {
                if (!response.data) {
                    nxtStep = this.state.currentStep;
                    isOpenPitneyBowesModel = true;
                }/* else if (this.state.selectedCarrier == "USPS" && selectedProviderIndex == "pitneyBowes") {
                    isAlreadyLoggedIn = true;
                }*/
            }).finally(() => {
                this.setState({ carrierConnectionBtnLoader: false });
            });
        }
        if (isAlreadyLoggedIn) {
            this.addCarrier();
        } else {
            if (this.state.selectedCarrier == "USPS") {
                let totalSteps = 2;
                let currentCarrierImgUrl = '3PL_Logo_Orange.png';
                let currentLoginLabel = 'Login';
                if (selectedProviderIndex == "Stamps.com") {
                    currentCarrierImgUrl = 'Stamps.com-logo.png';
                    currentLoginLabel = 'Stamps Account';
                } else if (selectedProviderIndex == "pitneyBowes") {
                    currentCarrierImgUrl = 'pitney-bowes-standard-logo.png';
                    currentLoginLabel = 'Pitney Bowes Expedited Account';
                } else if (selectedProviderIndex == "Endicia") {
                    currentCarrierImgUrl = 'endicia-logo.png';
                    currentLoginLabel = 'Endicia Account';
                } else if (selectedProviderIndex == "bukuShip") {
                    currentCarrierImgUrl = 'buku-ship.png';
                    currentLoginLabel = 'BukuShip Account';
                }
                this.setState({
                    currentCarrierImgUrl: currentCarrierImgUrl,
                    totalSteps: totalSteps,
                    currentLoginLabel: currentLoginLabel,
                });
            }
            this.setState({
                currentStep: nxtStep,
                isOpenPitneyBowesModel: isOpenPitneyBowesModel
            });
        }
    }

    updateCarrier = () => {

        this.setState({ carrierConnectionBtnLoader: true });

        carrierService.updateCarrier(this.state.currentCarrierObj, this.props.sharedSelectedCustomer.id).then((response) => {

            GlobalService.notification('success', this.translate('Label_Carrier_Update_Success'));

            this.props.onResetSelectionAndGridRefresh();
            this.props.closeCarrierConnection();

        }).finally(() => {
            this.setState({ carrierConnectionBtnLoader: false });
        });
    }

    addCarrier = () => {

        this.setState({ carrierConnectionBtnLoader: true });
        let tmpCurrentCarrierObj = Object.assign({}, this.state.currentCarrierObj);
        let carrierObj = this.state.carrierOptions[this.state.selectedCarrierIndex];
        let facilityObj = this.facilityOption[this.state.selectedFacilityIndex];
        let customerObj = this.customerOptions[this.state.selectedCustomerIndex];
        if (!customerObj) {
            customerObj = this.props.sharedSelectedCustomer;
        }

        tmpCurrentCarrierObj.CarrierName = carrierObj.Carrier;
        tmpCurrentCarrierObj.CarrierUri = carrierObj.Uri;
        // Set Customer Object
        tmpCurrentCarrierObj.CustomerId = customerObj.id;
        tmpCurrentCarrierObj.CustomerUri = customerObj.uri;

        if (this.isEnableProvider) {
            tmpCurrentCarrierObj.Provider = this.state.selectedProviderIndex;
            if (tmpCurrentCarrierObj.CarrierName == "USPS") {
                if (this.state.selectedProviderIndex == "Stamps.com") {
                    tmpCurrentCarrierObj.Provider = "shipEngine";
                    tmpCurrentCarrierObj.CarrierName = "Stamps.com";
                } else if (this.state.selectedProviderIndex == "Endicia") {
                    tmpCurrentCarrierObj.Provider = "shipEngine";
                    tmpCurrentCarrierObj.CarrierName = "Endicia";
                }  else if (this.state.selectedProviderIndex == "bukuShip") {
                    tmpCurrentCarrierObj.CarrierName = "Buku";
                } else if (this.state.selectedProviderIndex == "pitneyBowes") {
                    tmpCurrentCarrierObj.CarrierName = "PitneyBowesExp";
                    if(!tmpCurrentCarrierObj.ShipperRatePlan) {
                        tmpCurrentCarrierObj.ShipperRatePlan = "";
                    }
                    if(!tmpCurrentCarrierObj.IntegratorCarrierId) {
                        tmpCurrentCarrierObj.IntegratorCarrierId = "";
                    }
                    if(!tmpCurrentCarrierObj.MinimalAddressValidation) {
                        tmpCurrentCarrierObj.MinimalAddressValidation = false;
                    }
                }
            }
        }

        if (facilityObj && this.state.selectedContentType == 'Warehouse Account') {
            tmpCurrentCarrierObj.FacilityId = facilityObj.id;
            tmpCurrentCarrierObj.FacilityUri = facilityObj.uri;
        }


        if (tmpCurrentCarrierObj.CarrierName === "APC") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.Username;
        } else if (tmpCurrentCarrierObj.CarrierName === "Firstmile") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.MailerId;
        } else if (tmpCurrentCarrierObj.CarrierName === "Globegistics") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.Username;
        } else if (tmpCurrentCarrierObj.CarrierName === "Purolator") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.ApiKey;
        } else if (tmpCurrentCarrierObj.CarrierName === "RR Donnelley") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.Username;
        } else if (tmpCurrentCarrierObj.CarrierName === "SEKO") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.AccessKey;
        } else if (tmpCurrentCarrierObj.CarrierName === "ePost Global") {
            if(tmpCurrentCarrierObj.Provider == "shipEngine") {
                tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.Username;
            } else {
                tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.ApiToken;
            }
        } else if (tmpCurrentCarrierObj.CarrierName === "Landmark") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.Username;
        } else if (tmpCurrentCarrierObj.CarrierName === "PitneyBowesStd") {
            if(!tmpCurrentCarrierObj.MinimalAddressValidation) {
                tmpCurrentCarrierObj.MinimalAddressValidation = false;
            }
        } else if (tmpCurrentCarrierObj.CarrierName === "Pitney Bowes Cross-Border") {
            tmpCurrentCarrierObj.cbdsHub = tmpCurrentCarrierObj.cbdsHub || undefined;
            tmpCurrentCarrierObj.cbdsDeliverySolution = tmpCurrentCarrierObj.cbdsDeliverySolution || undefined;
            if(!tmpCurrentCarrierObj.MinimalAddressValidation) {
                tmpCurrentCarrierObj.MinimalAddressValidation = false;
            }
        } else if (tmpCurrentCarrierObj.CarrierName === "Lasership") {
            tmpCurrentCarrierObj.AccountNumber = tmpCurrentCarrierObj.WebServicesKey;
        }

        carrierService.addCarrier(tmpCurrentCarrierObj).then((response) => {
            // Check Auth URL Exist
            if (response && response.data.AuthUrl && (response.status == 200 || response.status == 204)) {
                this.setState({
                    carrierConnectionBtnLoader: false,
                    authUrl: response.data.AuthUrl,
                    upsAuthFlowCurrentStep: this.state.isFromResetLink ? 2 : 1,
                    isAuthUrl: true,
                    isAuthReset: this.state.isFromResetLink,
                    isFromResetLink: false,
                    isResetLinkCalling: false
                }, () => {
                    this.setLinkExpireTimer()
                });
            } else if (response && !response.data.AuthUrl && (response.status == 200 || response.status == 204)) {
                if(response && response.data.ShipEngineId) {
                    // Update Ship Engine Settings
                    tmpCurrentCarrierObj.ShipEngineId = response.data.ShipEngineId;
                    if(tmpCurrentCarrierObj.CarrierName == "UPS" || tmpCurrentCarrierObj.CarrierName == "FedEx" && tmpCurrentCarrierObj.Provider == "shipEngine") {
                        carrierService.updateCarrier(tmpCurrentCarrierObj, this.props.sharedSelectedCustomer.id);
                    }
                }
                GlobalService.notification('success', this.translate('New_carrier_Connection_Success'));
                this.props.onResetSelectionAndGridRefresh();
                setTimeout(() => {
                    this.props.closeCarrierConnection();
                }, 10);
            } else {
                GlobalService.notification('error', this.translate('Authorize_With_Failed'));
                this.setState({ carrierConnectionBtnLoader: false });
            }
        }).finally(() => {
            this.setState({ carrierConnectionBtnLoader: false });
        });
    }
    secondsToTime(secs){
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);
        let obj = {
          "h": hours,
          "m": minutes,
          "s": seconds.toLocaleString(undefined,{minimumIntegerDigits: 2})
        };
        return obj;
      }
    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
            isAuthReset: false
        });

        // Check if we're at zero.
        if (seconds == 0) {
            this.setState({
                showExpiredLinkMsg: true
            });
            clearInterval(this.timer);
        }
    }
    setLinkExpireTimer = () => {
        // setTimeout(() => {
            this.setState({
                showExpireLinkTimer: true,
                isFromResetLink: false,
                showExpiredLinkMsg: false,
                time: {},
                seconds: 600,
            })
            this.timer = setInterval(this.countDown, 1000);
        // }, 300000); // Interval start after 5 minutes
    }

    checkConnectionAuthorized = () => {

        if (this.state.upsAuthFlowCurrentStep > 0 && this.state.authUrl) {
            let tmpUpsAuthFlowCurrentStep = this.state.upsAuthFlowCurrentStep + 1;
            if(this.state.isHaveUpsAuthorization && this.state.authUrl) {
                window.open(this.state.authUrl, "_blank", "width=800,height=750,top=200,left=560,resizable=yes");
            }
            this.setState({
                upsAuthFlowCurrentStep: tmpUpsAuthFlowCurrentStep
            });
            return;
        }

        this.setState({ carrierConnectionBtnLoader: true });
        let tmpCurrentCarrierObj = Object.assign({}, this.state.currentCarrierObj);
        let carrierObj = this.state.carrierOptions[this.state.selectedCarrierIndex];
        let facilityObj = this.facilityOption[this.state.selectedFacilityIndex];
        let customerObj = this.customerOptions[this.state.selectedCustomerIndex];
        if (!customerObj) {
            customerObj = this.props.sharedSelectedCustomer;
        }

        tmpCurrentCarrierObj.CarrierName = carrierObj.Carrier;
        tmpCurrentCarrierObj.CarrierUri = carrierObj.Uri;
        tmpCurrentCarrierObj.Provider = this.state.selectedProviderIndex;
        tmpCurrentCarrierObj.SyncWithProvider = this.state.selectedProviderIndex;
        // Set Customer Object
        tmpCurrentCarrierObj.CustomerId = customerObj.id;
        tmpCurrentCarrierObj.CustomerUri = customerObj.uri;

        if (facilityObj && this.state.selectedContentType == 'Warehouse Account') {
            tmpCurrentCarrierObj.FacilityId = facilityObj.id;
            tmpCurrentCarrierObj.FacilityUri = facilityObj.uri;
        }

        carrierService.addCarrier(tmpCurrentCarrierObj).then((response) => {

            if(response && response.data.ShipEngineId) {
                // Update Ship Engine Settings
                tmpCurrentCarrierObj.ShipEngineId = response.data.ShipEngineId;
                carrierService.updateCarrier(tmpCurrentCarrierObj, this.props.sharedSelectedCustomer.id);
            }
            GlobalService.notification('success', this.translate('New_carrier_Connection_Success'));
            this.props.onResetSelectionAndGridRefresh();

            setTimeout(() => {
                this.props.closeCarrierConnection();
            }, 10);

        }).finally(() => {
            this.setState({
                carrierConnectionBtnLoader: false,
                isAuthUrl: false,
                authUrl: "",
                upsAuthFlowCurrentStep: 0,
                isHaveUpsAuthorization: null
            });
        });
    }
    resetLink = () => {
        this.setState({
            // upsAuthFlowCurrentStep: 0,
            isFromResetLink: true,
            isResetLinkCalling: true,
            isAuthReset: false,
            showExpiredLinkMsg: false,
            time: {},
            seconds: 300,
        }, () => {
            clearInterval(this.timer);
            this.addCarrier()
        })
    }

    checkConnectionAuthorizedFinal = () => {
        this.setState({ checkCarrierConnectionBtnLoader: true });

        let tmpCurrentCarrierObj = Object.assign({}, this.state.currentCarrierObj);
        let carrierObj = this.state.carrierOptions[this.state.selectedCarrierIndex];
        let facilityObj = this.facilityOption[this.state.selectedFacilityIndex];
        let customerObj = this.customerOptions[this.state.selectedCustomerIndex];
        if (!customerObj) {
            customerObj = this.props.sharedSelectedCustomer;
        }

        tmpCurrentCarrierObj.CarrierName = carrierObj.Carrier;
        tmpCurrentCarrierObj.CarrierUri = carrierObj.Uri;
        tmpCurrentCarrierObj.Provider = this.state.selectedProviderIndex;
        tmpCurrentCarrierObj.SyncWithProvider = this.state.selectedProviderIndex;
        // Set Customer Object
        tmpCurrentCarrierObj.CustomerId = customerObj.id;
        tmpCurrentCarrierObj.CustomerUri = customerObj.uri;

        if (facilityObj && this.state.selectedContentType == 'Warehouse Account') {
            tmpCurrentCarrierObj.FacilityId = facilityObj.id;
            tmpCurrentCarrierObj.FacilityUri = facilityObj.uri;
        }

        carrierService.addCarrier(tmpCurrentCarrierObj).then((response) => {

            if(response && response.data.ShipEngineId) {
                // Update Ship Engine Settings
                tmpCurrentCarrierObj.ShipEngineId = response.data.ShipEngineId;
                carrierService.updateCarrier(tmpCurrentCarrierObj, this.props.sharedSelectedCustomer.id);
            }
            if(response.status == 200 || response.status == 204) {
                this.setState({
                    isCarrierConnectionWorking: "Yes",
                    checkCarrierConnectionBtnLoader: false
                });
                this.props.onResetSelectionAndGridRefresh();
            } else {
                this.setState({
                    isCarrierConnectionWorking: "No",
                    checkCarrierConnectionBtnLoader: false
                });
            }

        });
    }

    tryAgainConnectionAuthorized = () => {
        if(this.state.isHaveUpsAuthorization && this.state.authUrl) {
            window.open(this.state.authUrl, "_blank", "width=800,height=750,top=200,left=560,resizable=yes");
        }
    }

    startOverConnectionAuthorize = () => {
        this.setState({
            carrierConnectionBtnLoader: false,
            isAuthUrl: false,
            authUrl: "",
            upsAuthFlowCurrentStep: 0,
            isHaveUpsAuthorization: null
        });
    }

    handelPitneyBowesChangeEvent = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    addPitneyBowesAccout = () => {
        let providerAccountObj = {};
        if (this.state.selectedProviderIndex == "pitneyBowes") {
            providerAccountObj = {
                Username: this.state.pitneyBowesUsername,
                Password: this.state.pitneyBowesPassword,
                Provider: this.state.selectedProviderIndex,
            }
        } else if (this.state.selectedProviderIndex == "bukuShip") {
            providerAccountObj = {
                Username: this.state.providerUsername,
                OrganizationNumber: this.state.providerOrganizationNumber,
                ConnectToken: this.state.providerConnectToken,
                Provider: this.state.selectedProviderIndex,
            }
        }
        this.setState({
            carrierConnectionBtnLoader: true,
            pitneyBowesErrorMessage: ''
        });
        carrierService.createProviderAccount(providerAccountObj).then((response) => {
            if (response.status == 200 || response.status == 204 ) {
                this.moveNextStep();
                // if (this.state.selectedCarrier == "USPS" && this.state.selectedProviderIndex == "pitneyBowes") {
                //     this.addCarrier();
                // } else {
                //     this.moveNextStep();
                // }
            } else {
                if (
                    response &&
                    response.response.status == 403
                ) {
                    this.setState({
                        pitneyBowesErrorMessage: this.translate('Label_incorrect_pitney_bowes_account')
                    });
                }
            }
        }).finally(() => {
            this.setState({ carrierConnectionBtnLoader: false });
        });
    }

    onClosePitneyBowesModel = () => {
        this.setState({
            isOpenPitneyBowesModel: false
        });
    }

    onClickCreatePitneyAccount = () => {
        if (this.state.selectedProviderIndex == "pitneyBowes") {
            window.open('https://www.pbshippingmerchant.pitneybowes.com/home?developerID=95490479', '_blank');
        } else {
            window.open('https://www.bukuship.com/extensiv', '_blank');
        }
    }

    onClickUpsAuthorization = (event) => {
        if(event.target.name === "haveAuthoration") {
            this.setState({
                isHaveUpsAuthorization: true
            });
        } else {
            this.setState({
                isHaveUpsAuthorization: false
            });
        }
    }
    createContainerElement() {
        if (document.getElementById("auth-clipboard") == null) {
            let container = document.createElement('div');
            container.id = 'auth-clipboard-container';
            container.setAttribute('style', ['opacity: 0;height: 0;width: 0;'].join(''));
            document.body.appendChild(container);
            let textarea = document.createElement('textarea');
            textarea.id = 'auth-clipboard';
            textarea = textarea;
            container.appendChild(textarea);
        }
    }
    copyInstructionToClipBoard = () => {
        var copyText = 'To connect your UPS account to your 3PL’s warehouse management system:' + '\n';
        copyText += 'Go to: \n' + this.state.authUrl + '\n';
        copyText += 'Log in with your UPS account' + '\n';
        copyText += 'This link is valid for 10 minutes.' + '\n';
        var copyTextarea = document.querySelector('#auth-clipboard');
        copyTextarea.appendChild(document.createTextNode(copyText));
        copyTextarea.select();
        document.execCommand('copy');
        $('#auth-clipboard').text('');
        GlobalService.notification('success', this.translate("Label_Instruction_Copied"));
    }
    copyLinkToClipBoard = () => {
        var copyText = this.state.authUrl;
        var copyTextarea = document.querySelector('#auth-clipboard');
        copyTextarea.appendChild(document.createTextNode(copyText));
        copyTextarea.select();
        document.execCommand('copy');
        $('#auth-clipboard').text('');
        GlobalService.notification('success', this.translate("Label_Link_Copied"));
    }

    render() {

        let carrierAccountInformationSection = () => {
            switch (this.state.selectedCarrier) {
                case 'Endicia':
                    return <EndiciaAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'DHL eCommerce':
                    return <DHLeCommerceAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                        currentLoginLabel={this.state.currentLoginLabel}
                    />;
                case 'DHL Express':
                    return <DHLExpressAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Australia Post':
                    return <AustraliaPostAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'PitneyBowesStd':
                    return <PitneyBowesStandardInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Stamps.com':
                    return <StampsAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'APC':
                    return <APCAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Purolator':
                    return <PurolatorAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                        currentLoginLabel={this.state.currentLoginLabel}
                    />;
                case 'DHL Express Australia':
                    return <DHLExpressAUAccountInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                        currentLoginLabel={this.state.currentLoginLabel}
                    />;
                case 'Firstmile':
                    return <FirstMileInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Globegistics':
                    return <GlobegisticsInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'RR Donnelley':
                    return <RrDonnelleyInfoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Canada Post':
                    return <CanadaPostComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'OnTrac':
                    return <OnTraceComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'SEKO':
                    return <SekoComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Amazon Buy':
                    return <AmazonComponent
                        selector={this.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Canpar':
                    return <CanparAccountInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'USPS':
                    switch (this.state.selectedProviderIndex) {
                        case 'pitneyBowes':
                            return <PitneyBowesExpeditedInfoComponent
                                selector={this.selector}
                                currentCarrierObj={this.state.currentCarrierObj}
                                handleCarrierObjChange={this.handleCarrierObjChange}
                            />;
                        case "Stamps.com":
                            return <StampsAccountInfoComponent
                                selector={this.selector}
                                currentCarrierObj={this.state.currentCarrierObj}
                                handleCarrierObjChange={this.handleCarrierObjChange}
                            />
                        case "Endicia":
                            return <EndiciaAccountInfoComponent
                                selector={this.selector}
                                currentCarrierObj={this.state.currentCarrierObj}
                                handleCarrierObjChange={this.handleCarrierObjChange}
                            />
                        case "bukuShip":
                            return <USPSBukuShipAccountInfoComponent
                                selector={this.selector}
                                currentCarrierObj={this.state.currentCarrierObj}
                                handleCarrierObjChange={this.handleCarrierObjChange}
                                optionsState={this.state.optionsState}
                                optionsCountry={this.optionsCountry}
                            />;
                        default:
                            return <div className="default-section">
                                We are currently building out the connection user interface for this carrier and expect to complete it soon. If you need this carrier set up immediately, please contact your Customer Success Manager to begin the process.
                            </div>;
                    }
                case 'Landmark':
                    return <LandmarkAccountInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'ePost Global':
                    return <EpostGlobalAccountInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        selectedProvider={this.state.selectedProviderIndex}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Cirro E-Commerce':
                    return <ParcllAccountInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Pitney Bowes Cross-Border':
                    return <PitneyBowesCrossBorderInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Stallion Express':
                    return <StallionAccountInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'UPS Mail Innovations':
                        return <UpsmiAccountInfoComponent
                            selector={this.state.selector}
                            currentCarrierObj={this.state.currentCarrierObj}
                            handleCarrierObjChange={this.handleCarrierObjChange}
                        />;
                case 'FedEx SmartPost':
                    return <FedExSmartPostAccountInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                        optionsState={this.state.optionsState}
                        optionsCountry={this.optionsCountry}
                    />;
                case 'UPS SurePost':
                    return <UpsSurePostAccountInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Passport':
                    return <PassportInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Sendle':
                    return <SendleInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Tusk Logistics':
                    return <TuskInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Flexport':
                    return <FlexportInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                case 'Lasership':
                    return <LasershipInfoComponent
                        selector={this.state.selector}
                        currentCarrierObj={this.state.currentCarrierObj}
                        handleCarrierObjChange={this.handleCarrierObjChange}
                    />;
                default:
                    return <div className="default-section">
                        We are currently building out the connection user interface for this carrier and expect to complete it soon. If you need this carrier set up immediately, please contact your Customer Success Manager to begin the process.
                    </div>;
            }
        };
        return (

            <WmsModel
                id={'newCarrierConnection'}
                title={
                    this.state.isOpenPitneyBowesModel ? this.translate('Label_Add_Pitney_Bowes_Carrier_Model').replace(new RegExp('{' + 'provider' + '}', 'gi'), this.selectedProviderObj ? this.selectedProviderObj.DisplayName : '') :
                    (this.props.sharedCarrierConnectionFlow == 'create' ? this.translate('Title_New_carrier_Connection_Model') :
                        this.translate("Title_Edit_Carrier_Account").replace(new RegExp("{selectedCarrierName}"), this.state.selectedCarrier.toLocaleUpperCase()))
                }
                width={800}
                height={750}
                class='new-carrier-connection-wrapper'
                onCloseFunc={this.props.closeCarrierConnection}
                isOpen={this.props.isOpenCarrierConnectionModel}
                customClass='wms-model-new-ui-wrapper'>
                <div className="model-content-wrapper">
                    {/* First step */}
                    {this.props.sharedCarrierConnectionFlow == 'edit' && (
                        <div className="connection-step-block">
                            <div className={"image-section " + (this.state.selectedCarrier == 'Amazon Buy' ? 'img-amazon' : '')}>
                                <img src={'assets/images/' + this.state.currentCarrierImgUrl} />
                            </div>
                            {this.state.selectedCarrier == 'FedEx' ?
                                <FedexEditComponent
                                    selector={this.selector}
                                    currentCarrierObj={this.state.currentCarrierObj}
                                    selectedCustomerName={this.selectedCustomerName}
                                    handleCarrierObjChange={this.handleCarrierObjChange} />
                            : this.state.selectedCarrier == "UPS" ?
                                <UpsEditComponent
                                    selector={this.selector}
                                    currentCarrierObj={this.state.currentCarrierObj}
                                    selectedCustomerName={this.selectedCustomerName}
                                    handleCarrierObjChange={this.handleCarrierObjChange} />
                            :
                                <CarriersEditComponent
                                    selector={this.selector}
                                    currentCarrierObj={this.state.currentCarrierObj}
                                    selectedCustomerName={this.selectedCustomerName}
                                    handleCarrierObjChange={this.handleCarrierObjChange} />
                            }
                        </div>
                    )}
                    {this.state.upsAuthFlowCurrentStep == 0 && this.props.sharedCarrierConnectionFlow == 'create' && this.state.currentStep == 1 && !this.state.isOpenPitneyBowesModel && (
                        <div className={"wms-carrier-connection " + this.carrierElementClass}>
                            <WmsCollapse
                                id={'carrierSelectConnection'}
                                headerLabel={this.translate("Label_Carrier_Select")}
                                showCollapseText={false}
                                showCollapseIcon={false} >

                                <WmsDropdown
                                    id="selectedContentType"
                                    name="selectedContentType"
                                    label={this.translate('Label_Connection_Type')}
                                    wmsSelector={this.selector + "contentType"}
                                    onChangeFunc={this.handleChangeEvent}
                                    value={this.state.selectedContentType}
                                    options={[{
                                        'Text': 'Warehouse Account',
                                        'Value': 'Warehouse Account',
                                    }, {
                                        'Text': 'Customer Account',
                                        'Value': 'Customer Account',
                                    }]}
                                    valueField='Value'
                                    textField='Text'
                                    parentClassName='form_group'
                                    blankFirstOption={true}
                                    extraWrapperClass={"new-connection-first-element"} />
                                {/* <div className={this.state.selectedContentType == 'Customer Account' ? 'disabled-facility-opt':''}> */}
                                {this.state.selectedContentType == 'Customer Account' ? (
                                    <WmsDropdown
                                        id="selectedCustomerIndex"
                                        name="selectedCustomerIndex"
                                        label={this.translate('FindOrders_Lbl_Customer')}
                                        wmsSelector={this.selector + "customer"}
                                        onChangeFunc={this.handleChangeEvent}
                                        value={this.state.selectedCustomerIndex}
                                        options={this.customerOptions}
                                        valueField='id'
                                        textField='name'
                                        parentClassName='form_group'
                                        applyIndex={true}
                                        blankFirstOption={true}
                                        extraWrapperClass={"new-connection-second-element"} />
                                ) : (
                                    <WmsDropdown
                                        id="selectedFacilityIndex"
                                        name="selectedFacilityIndex"
                                        label={this.translate('Label_Warehouse_Text')}
                                        wmsSelector={this.selector + "facility"}
                                        onChangeFunc={this.handleChangeEvent}
                                        value={this.state.selectedFacilityIndex}
                                        options={this.facilityOption}
                                        valueField='id'
                                        textField='name'
                                        parentClassName='form_group'
                                        applyIndex={true}
                                        blankFirstOption={true}
                                        extraWrapperClass={"new-connection-second-element"} />
                                )}
                                {/* </div> */}

                                <WmsDropdown
                                    id="selectedCarrierIndex"
                                    name="selectedCarrierIndex"
                                    label={this.translate('Label_Carrier')}
                                    wmsSelector={this.selector + "carrier"}
                                    onChangeFunc={this.handleChangeEvent}
                                    value={this.state.selectedCarrierIndex}
                                    options={this.state.carrierOptions}
                                    valueField='Carrier'
                                    textField='DisplayName'
                                    parentClassName='form_group'
                                    applyIndex={true}
                                    blankFirstOption={true}
                                    extraWrapperClass={"new-connection-third-element"} />

                                {this.isEnableProvider &&
                                    <WmsDropdown
                                        id="selectedProviderIndex"
                                        name="selectedProviderIndex"
                                        label={this.translate('Label_Provider')}
                                        wmsSelector={this.selector + "service"}
                                        onChangeFunc={this.handleChangeEvent}
                                        value={this.state.selectedProviderIndex}
                                        options={this.state.providerOptions}
                                        valueField='Code'
                                        textField='DisplayName'
                                        parentClassName='form_group'
                                        applyIndex={false}
                                        blankFirstOption={true}
                                        disabled={this.state.selectedCarrierIndex == '' ? true : false}
                                        extraWrapperClass={"new-connection-third-element"} />
                                }
                                {this.state.selectedContentType &&
                                    <div className="display-include-cost">
                                        <WmsCheckBox
                                            id={'IncludeShippingCost'}
                                            name={'IncludeShippingCost'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate("Label_Include_Shipping_Cost")}
                                            checked={this.state.currentCarrierObj.IncludeShippingCost}
                                            value={this.state.currentCarrierObj.IncludeShippingCost}
                                            wmsSelector={this.selector + "IncludeShippingCost"}
                                            disabled={!this.state.selectedContentType} />
                                    </div>
                                }
                                {this.state.selectedContentType == 'Customer Account' &&
                                    <div className="display-include-cost">
                                        <p>For this account, label charges will be recorded and added to your invoice for <b>{this.selectedCustomerName}</b>.</p>
                                    </div>
                                }
                                {this.state.selectedContentType == 'Warehouse Account' &&
                                    <div className="display-include-cost">
                                        <p>For this account, label charges will be recorded and added to your invoice for <b>all customers in this warehouse.</b></p>
                                    </div>
                                }
                                {this.state.currentCarrierObj.IncludeShippingCost && this.state.selectedContentType == 'Customer Account' &&
                                    <div className="display-include-cost">
                                        <div className='alert-text-wrapper'>
                                            <i className="far fa-triangle-exclamation" aria-hidden="true"></i>
                                            <span>{this.translate("Label_Include_Shipping_Cost_Warning")}</span>
                                        </div>
                                    </div>
                                }
                            </WmsCollapse>
                        </div>
                    )}

                    {this.state.upsAuthFlowCurrentStep == 0 && this.state.currentStep == 1 && this.state.isOpenPitneyBowesModel && (
                        <div className="pitney-bowes-connection-step-block">
                            <div className="image-section">
                                { this.state.selectedProviderIndex && this.state.selectedProviderIndex == "pitneyBowes" ? (
                                    <img src={'assets/images/pitney-bowes-logo.png'} />
                                ) : this.state.selectedProviderIndex && this.state.selectedProviderIndex == "bukuShip" && (
                                    <img src={'assets/images/buku-ship.png'} />
                                ) }
                            </div>
                            <WmsCollapse
                                id={'pitneyBowesConnectionLoginDetail'}
                                headerLabel={this.translate("Label_Account_Login")}
                                showCollapseText={false}
                                showCollapseIcon={false} >
                                    <div className="title">
                                        <div className="wms-sprite fa fa-exclamation-triangle"></div>
                                        { this.state.selectedProviderIndex && this.state.selectedProviderIndex == "pitneyBowes" ? (
                                            <span>{this.translate("Label_pitney_bowes_account_connect_new")}</span>
                                        ) : this.state.selectedProviderIndex && this.state.selectedProviderIndex == "bukuShip" && (
                                            <span>{this.translate("Label_pitney_bowes_account_connect").replace(new RegExp('{' + 'carrier_account' + '}', 'gi'), this.state.carrierOptions[this.state.selectedCarrierIndex] ? this.state.carrierOptions[this.state.selectedCarrierIndex].Carrier : '').replace(new RegExp('{' + 'provider' + '}', 'gi'), this.selectedProviderObj ? this.selectedProviderObj.DisplayName : '')}</span>
                                        ) }
                                    </div>
                                    {this.state.pitneyBowesErrorMessage != '' &&
                                        <div className="pitneyBoweserror">
                                            <div className="wms-sprite fa fa-exclamation-triangle"></div>
                                            <span>{ this.state.pitneyBowesErrorMessage }</span>
                                        </div>
                                    }

                                    {
                                        this.state.selectedProviderIndex == "pitneyBowes" ?
                                            <div className="pitney-bowes-middel-wrapper">
                                                <div className='pitney-bowes-credentials'>
                                                    <WmsInput
                                                        id='pitney-bowes-username'
                                                        inputName='pitneyBowesUsername'
                                                        autoComplete='off'
                                                        wmsSelector={this.selector + 'pitneyBowesUsername'}
                                                        onChangeFunc={this.handelPitneyBowesChangeEvent}
                                                        label={this.translate('Label_Username')}
                                                        value={this.state.pitneyBowesUsername}
                                                    />
                                                    <WmsInput
                                                        inputType='password'
                                                        id='pitney-bowes-password'
                                                        inputName='pitneyBowesPassword'
                                                        autoComplete="new-password"
                                                        wmsSelector={this.selector + 'pitneyBowesPassword'}
                                                        onChangeFunc={this.handelPitneyBowesChangeEvent}
                                                        label={this.translate('Login_Lbl_Password')}
                                                        value={this.state.pitneyBowesPassword}
                                                    />
                                                </div>
                                                <div className="pitney-bowes-seprator-wrapper">
                                                    <div className="pitney-bowes-seprator-word">OR</div>
                                                </div>
                                                <div className='pitney-bowes-create-account-btn'>
                                                    <WmsButton
                                                        label={this.translate('Label_new_pitney_bowes_account').replace(new RegExp('{' + 'provider' + '}', 'gi'), this.selectedProviderObj ? this.selectedProviderObj.DisplayName : '')}
                                                        buttonType='green'
                                                        wmsSelector={this.selector + 'pitneyBowesCreateAccount'}
                                                        onClickFunc={this.onClickCreatePitneyAccount}
                                                        icon='fa-plus' />
                                                </div>
                                            </div>
                                        :
                                        <div className="pitney-bowes-middel-wrapper">
                                            <div className='pitney-bowes-credentials'>
                                                <WmsInput
                                                    id='providerUsername'
                                                    inputName='providerUsername'
                                                    autoComplete='off'
                                                    wmsSelector={this.selector + 'providerUsername'}
                                                    onChangeFunc={this.handelPitneyBowesChangeEvent}
                                                    label={this.translate('Label_Username')}
                                                    value={this.state.providerUsername}
                                                />
                                                <WmsInput
                                                    inputType='text'
                                                    id='providerOrganizationNumber'
                                                    inputName='providerOrganizationNumber'
                                                    wmsSelector={this.selector + 'providerOrganizationNumber'}
                                                    onChangeFunc={this.handelPitneyBowesChangeEvent}
                                                    label={this.translate('Lbl_Organization_Number')}
                                                    value={this.state.providerOrganizationNumber}
                                                />
                                                <WmsInput
                                                    inputType='text'
                                                    id='providerConnectToken'
                                                    inputName='providerConnectToken'
                                                    wmsSelector={this.selector + 'providerConnectToken'}
                                                    onChangeFunc={this.handelPitneyBowesChangeEvent}
                                                    label={this.translate('Lbl_Connect_Token')}
                                                    value={this.state.providerConnectToken}
                                                />
                                            </div>
                                            <div className="pitney-bowes-seprator-wrapper">
                                                <div className="pitney-bowes-seprator-word">OR</div>
                                            </div>
                                            <div className='pitney-bowes-create-account-btn'>
                                                <WmsButton
                                                    label={this.translate('Label_new_pitney_bowes_account').replace(new RegExp('{' + 'provider' + '}', 'gi'), this.selectedProviderObj ? this.selectedProviderObj.DisplayName : '')}
                                                    buttonType='green'
                                                    wmsSelector={this.selector + 'pitneyBowesCreateAccount'}
                                                    onClickFunc={this.onClickCreatePitneyAccount}
                                                    icon='fa-plus' />
                                            </div>
                                        </div>
                                    }
                            </WmsCollapse>
                        </div>
                    ) }

                    {/* Second step */}
                    {this.state.upsAuthFlowCurrentStep == 0 && this.state.currentStep == 2 && (
                        <div className="connection-step-block">
                            <div className={"image-section " + (this.state.selectedCarrier == 'Amazon Buy' ? 'img-amazon' : '')}>
                                <img src={'assets/images/' + this.state.currentCarrierImgUrl} />
                            </div>

                            {this.state.selectedCarrier == 'FedEx' ? (
                                <WmsCollapse
                                    id={'carrierAgreementSection'}
                                    headerLabel={this.translate("Label_Agreement")}
                                    showCollapseText={false}
                                    showCollapseIcon={false} >
                                    {this.state.selectedCarrier == 'FedEx' ?
                                        <FedexEulaAgreementComponent /> :
                                        <UpsEulaAgreementComponent />
                                    }
                                    <WmsCheckBox
                                        id={'agreeToEula'}
                                        name={"AgreeToEula"}
                                        wmsSelector={this.selector + 'agreeToEula'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Agree_Terms')}
                                        checked={this.state.currentCarrierObj.AgreeToEula == true}
                                        isRounded={true}
                                        value={this.state.currentCarrierObj.AgreeToEula}
                                    />

                                </WmsCollapse>
                            ) : this.state.selectedCarrier == "UPS" ? (
                                <WmsCollapse
                                    id={'carrierAccountInformation'}
                                    headerLabel={this.translate("Label_Account_Information")}
                                    showCollapseText={false}
                                    showCollapseIcon={false} >
                                    <WmsInput
                                        id='nickname'
                                        inputName='Nickname'
                                        wmsSelector={this.selector + 'nickname'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Account_Nick_Name')}
                                        extraWrapperClass="wms-input-city-box"
                                        required={true}
                                        value={this.state.currentCarrierObj.Nickname} />

                                    <WmsInput
                                        id='accountNumber'
                                        inputName='AccountNumber'
                                        wmsSelector={this.selector + 'accountNumber'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Account_Number')}
                                        extraWrapperClass="wms-input-city-box"
                                        required={true}
                                        value={this.state.currentCarrierObj.AccountNumber} />

                                    <WmsDropdown
                                        id="accountCountryCode"
                                        name="AccountCountryCode"
                                        label={this.translate('Label_Account_Country')}
                                        wmsSelector={this.selector + "accountCountryCode"}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        value={this.state.currentCarrierObj.AccountCountryCode}
                                        options={this.optionsCountry}
                                        valueField='CountryCode'
                                        textField='Name'
                                        parentClassName='form_group'
                                        required={true}
                                        extraWrapperClass="wms-dropdown-account-country-box"
                                    />

                                    <WmsInput
                                        id='accountPostalCode'
                                        inputName='AccountPostalCode'
                                        wmsSelector={this.selector + 'accountzip'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Account_Zip')}
                                        required={true}
                                        value={this.state.currentCarrierObj.AccountPostalCode}
                                        extraWrapperClass="wms-input-account-zip-box"
                                    />
                                </WmsCollapse>
                            ) : (
                                <div>
                                    {carrierAccountInformationSection()}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Third step */}
                    {this.state.upsAuthFlowCurrentStep == 0 && this.state.currentStep == 3 && (
                        <div className="connection-step-block">
                            <div className="image-section">
                                <img src={'assets/images/' + this.state.currentCarrierImgUrl} />
                            </div>

                            {this.state.selectedCarrier == "FedEx" && (
                                <WmsCollapse
                                    id={'carrierCompoanyInformation'}
                                    headerLabel={this.translate("Label_Company_Information")}
                                    showCollapseText={false}
                                    showCollapseIcon={false} >

                                    <div className='display-inline'>
                                        <WmsInput
                                            id='firstName'
                                            inputName='FirstName'
                                            wmsSelector={this.selector + 'firstName'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Warehouse_First_Name')}
                                            extraWrapperClass={this.state.selectedCarrier == "UPS" ? 'ups-first-name wms-input-names-box' : 'wms-input-names-box'}
                                            value={this.state.currentCarrierObj.FirstName} />

                                        <WmsInput
                                            id='lastName'
                                            inputName='LastName'
                                            wmsSelector={this.selector + 'lastName'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Warehouse_Last_Name')}
                                            extraWrapperClass="wms-input-title-box"
                                            value={this.state.currentCarrierObj.LastName} />
                                    </div>

                                    {this.state.selectedCarrier == "UPS" &&
                                        <div className='display-inline ups-section'>
                                            <WmsInput
                                                id='contactTitle'
                                                inputName='ContactTitle'
                                                wmsSelector={this.selector + 'contactTitle'}
                                                onChangeFunc={this.handleCarrierObjChange}
                                                label={this.translate('Label_Title')}
                                                extraWrapperClass="wms-input-title-box"
                                                value={this.state.currentCarrierObj.ContactTitle} />
                                        </div>
                                    }

                                    <WmsInput
                                        id='company'
                                        inputName='Company'
                                        wmsSelector={this.selector + 'company'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Company_Name')}
                                        extraWrapperClass={this.state.selectedCarrier == "UPS" ? 'ups-company-name wms-input-names-box' : 'wms-input-names-box'}
                                        value={this.state.currentCarrierObj.Company}
                                    />

                                    <WmsInput
                                        id='phone'
                                        inputName='Phone'
                                        wmsSelector={this.selector + 'phoneNumber'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Warehouse_PhoneNumber')}
                                        extraWrapperClass="wms-input-title-box"
                                        value={this.state.currentCarrierObj.Phone}
                                        valueType="number"
                                    />

                                    <WmsInput
                                        id='email'
                                        inputName='Email'
                                        wmsSelector={this.selector + 'emailAddress'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Email_Address')}
                                        extraWrapperClass="wms-input-address-box"
                                        value={this.state.currentCarrierObj.Email}
                                    />

                                    <WmsInput
                                        id='address1'
                                        inputName='Address1'
                                        wmsSelector={this.selector + 'address1'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Address_1')}
                                        extraWrapperClass="wms-input-address-half-box"
                                        value={this.state.currentCarrierObj.Address1}
                                    />
                                    <WmsInput
                                        id='address2'
                                        inputName='Address2'
                                        wmsSelector={this.selector + 'address2'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Address_2')}
                                        extraWrapperClass="wms-input-address-half-box"
                                        value={this.state.currentCarrierObj.Address2}
                                    />

                                    <WmsInput
                                        id='city'
                                        inputName='City'
                                        wmsSelector={this.selector + 'city'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Warehouse_City')}
                                        extraWrapperClass="wms-input-city-box"
                                        value={this.state.currentCarrierObj.City}
                                    />

                                    <WmsDropdown
                                        id="state"
                                        name="State"
                                        label={this.translate('Label_Costomer_State_Province')}
                                        wmsSelector={this.selector + "state'"}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        disabled={this.state.currentCarrierObj.CountryCode ? false : true}
                                        value={this.state.currentCarrierObj.State}
                                        options={this.state.optionsState}
                                        valueField='RegionCode'
                                        textField='Name'
                                        parentClassName='form_group'
                                        extraWrapperClass="wms-dropdown-state-box"
                                    />

                                    <WmsInput
                                        id='postalCode'
                                        inputName='PostalCode'
                                        wmsSelector={this.selector + 'zip'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Account_Zip_Postal_code')}
                                        extraWrapperClass="wms-input-zip-postal-code-box"
                                        value={this.state.currentCarrierObj.PostalCode}
                                    />

                                    <WmsDropdown
                                        id="countryCode"
                                        name="CountryCode"
                                        label={this.translate('Label_Country')}
                                        wmsSelector={this.selector + "country"}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        value={this.state.currentCarrierObj.CountryCode}
                                        options={this.optionsCountry}
                                        valueField='CountryCode'
                                        textField='Name'
                                        parentClassName='form_group'
                                        extraWrapperClass="wms-dropdown-country-box" />


                                </WmsCollapse>
                            )}

                            {this.state.selectedCarrier == "FedEx" && (
                                <WmsCollapse
                                    id={'carrierAccountInformation'}
                                    headerLabel={this.translate("Label_Account_Information")}
                                    showCollapseText={false}
                                    showCollapseIcon={false} >
                                    <WmsInput
                                        id='nickname'
                                        inputName='Nickname'
                                        wmsSelector={this.selector + 'nickname'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Account_Nick_Name')}
                                        extraWrapperClass="wms-input-city-box"
                                        value={this.state.currentCarrierObj.Nickname} />
                                    <WmsInput
                                        id='accountNumber'
                                        inputName='AccountNumber'
                                        wmsSelector={this.selector + 'accountNumber'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Account_Number')}
                                        extraWrapperClass="wms-input-city-box"
                                        required={true}
                                        value={this.state.currentCarrierObj.AccountNumber} />
                                    {this.state.selectedCarrier == "UPS" && (
                                        <div>
                                            <WmsDropdown
                                                id="accountCountryCode"
                                                name="AccountCountryCode"
                                                label={this.translate('Label_Account_Country')}
                                                wmsSelector={this.selector + "accountCountryCode"}
                                                onChangeFunc={this.handleCarrierObjChange}
                                                value={this.state.currentCarrierObj.AccountCountryCode}
                                                options={this.optionsCountry}
                                                valueField='CountryCode'
                                                textField='Name'
                                                parentClassName='form_group'
                                                extraWrapperClass="wms-dropdown-account-country-box"
                                            />

                                            <WmsInput
                                                id='accountPostalCode'
                                                inputName='AccountPostalCode'
                                                wmsSelector={this.selector + 'accountzip'}
                                                onChangeFunc={this.handleCarrierObjChange}
                                                label={this.translate('Label_Account_Zip')}
                                                value={this.state.currentCarrierObj.AccountPostalCode}
                                                extraWrapperClass="wms-input-account-zip-box"
                                            />
                                        </div>
                                    )}
                                    {this.state.selectedCarrier != 'FedEx' && (
                                        <WmsCheckBox
                                            id={'invoiceReceivedInPast90Days'}
                                            name={"InvoiceReceivedInPast90Days"}
                                            wmsSelector={this.selector + 'chkInvoice'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Invoice')}
                                            checked={this.state.currentCarrierObj.InvoiceReceivedInPast90Days == true}
                                            isRounded={true}
                                            value={this.state.currentCarrierObj.InvoiceReceivedInPast90Days}
                                        />
                                    )}
                                </WmsCollapse>
                            )}

                            {this.state.selectedCarrier == 'FedEx' && (
                                <WmsCollapse
                                    id={'carrierSettings'}
                                    headerLabel={this.translate("Label_Settings")}
                                    showCollapseText={false}
                                    showCollapseIcon={false} >

                                    <div className="dropdown_section">
                                        <WmsDropdown
                                            id="pickupType"
                                            name="PickupType"
                                            label={this.translate('Label_Pickup_Type')}
                                            wmsSelector={this.selector + "PickupType"}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            value={this.state.currentCarrierObj.PickupType}
                                            options={this.state.pickupTypeOptions}
                                            valueField='value'
                                            textField='name'
                                            blankFirstOption={true}
                                        />

                                        <WmsDropdown
                                            id="smartPostHub"
                                            name="SmartPostHub"
                                            label={this.translate('Label_Smart_Post_Hub')}
                                            wmsSelector={this.selector + "SmartPostHub"}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            value={this.state.currentCarrierObj.SmartPostHub}
                                            options={this.state.smartPostHubOptions}
                                            valueField='value'
                                            textField='name'
                                            blankFirstOption={true}
                                        />
                                        <WmsDropdown
                                            id="smartPostEndorsement"
                                            name="SmartPostEndorsement"
                                            label={this.translate('Label_Smart_Post_Endorsement')}
                                            wmsSelector={this.selector + "SmartPostEndorsement"}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            value={this.state.currentCarrierObj.SmartPostEndorsement}
                                            options={this.state.smartPostEndorsementOptions}
                                            valueField='value'
                                            textField='name'
                                            blankFirstOption={true}
                                        />
                                    </div>

                                    <div className="radio_section">
                                        <WmsCheckBox
                                            id={'isPrimaryAccount'}
                                            name={"IsPrimaryAccount"}
                                            wmsSelector={this.selector + 'PrimaryAccount'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Primary_Account')}
                                            checked={this.state.currentCarrierObj.IsPrimaryAccount == true}
                                            isRounded={true}
                                        />
                                    </div>
                                </WmsCollapse>
                            )}

                            {this.state.selectedCarrier == "UPS" && (
                                <WmsCollapse
                                    id={'carrierSettings'}
                                    headerLabel={this.translate("Label_Settings")}
                                    showCollapseText={false}
                                    showCollapseIcon={false} >

                                    <div className="dropdown_section">
                                        <WmsDropdown
                                            id="pickupType"
                                            name="PickupType"
                                            label={this.translate('Label_Pickup_Type')}
                                            wmsSelector={this.selector + "PickupType"}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            value={this.state.currentCarrierObj.PickupType}
                                            options={this.state.pickupTypeOptions}
                                            valueField='value'
                                            textField='name'
                                            blankFirstOption={true}
                                        />
                                    </div>

                                    <div className="mail_section">
                                        <WmsDropdown
                                            id="mailInnovationsEndorsement"
                                            name="MailInnovationsEndorsement"
                                            label={this.translate('Label_Mail_Innovations_Endorsement')}
                                            wmsSelector={this.selector + "MailInnovationsEndorsement"}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            value={this.state.currentCarrierObj.MailInnovationsEndorsement}
                                            options={this.state.mailInnovationsEndorsementOptions}
                                            valueField='value'
                                            textField='name'
                                            blankFirstOption={true}
                                        />

                                        <WmsInput
                                            id='mailInnovationsCostCenter'
                                            inputName='MailInnovationsCostCenter'
                                            wmsSelector={this.selector + 'MailInnovationsCostCenter'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Mail_Innovations_Cost_Center')}
                                            value={this.state.currentCarrierObj.MailInnovationsCostCenter}
                                        />
                                    </div>

                                    <div className="mail_section">
                                        <WmsInput
                                            id='mailInnovationsCustomerId'
                                            inputName='MailInnovationsCustomerId'
                                            wmsSelector={this.selector + 'MailInnovationsCustomerId'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Mail_Innovations_Customer_Id')}
                                            value={this.state.currentCarrierObj.MailInnovationsCustomerId}
                                            regularExp={/(^[0-9]+$|^$)/}
                                            maxLength={6}
                                        />

                                        <WmsInput
                                            id='mailInnovationsCustomerGuid'
                                            inputName='MailInnovationsCustomerGuid'
                                            wmsSelector={this.selector + 'MailInnovationsCustomerGuid'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Mail_Innovations_Customer_Guid')}
                                            value={this.state.currentCarrierObj.MailInnovationsCustomerGuid}
                                        />
                                    </div>

                                    <div className="radio_section">
                                        <WmsCheckBox
                                            id={'useOrderNumberOnMailInnovationsLabels'}
                                            name={"UseOrderNumberOnMailInnovationsLabels"}
                                            wmsSelector={this.selector + 'UseOrderNumberOnMailInnovationsLabels'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Order_Number_On_Mail_Innovations_Labels')}
                                            checked={this.state.currentCarrierObj.UseOrderNumberOnMailInnovationsLabels == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'useConsolidationServices'}
                                            name={"UseConsolidationServices"}
                                            wmsSelector={this.selector + 'UseConsolidationServices'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Consolidation_Services')}
                                            checked={this.state.currentCarrierObj.UseConsolidationServices == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'useNegotiatedRates'}
                                            name={"UseNegotiatedRates"}
                                            wmsSelector={this.selector + 'UseNegotiatedRates'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Negotiated_Rates')}
                                            checked={this.state.currentCarrierObj.UseNegotiatedRates == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'useCarbonNeutralShippingProgram'}
                                            name={"UseCarbonNeutralShippingProgram"}
                                            wmsSelector={this.selector + 'UseCarbonNeutralShippingProgram'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Carbon_Neutral_Shipping_Program')}
                                            checked={this.state.currentCarrierObj.UseCarbonNeutralShippingProgram == true}
                                            isRounded={true}
                                        />


                                        <WmsCheckBox
                                            id={'useGroundFreightPricing'}
                                            name={"UseGroundFreightPricing"}
                                            wmsSelector={this.selector + 'UseGroundFreightPricing'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Ground_Freight_Pricing')}
                                            checked={this.state.currentCarrierObj.UseGroundFreightPricing == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'isPrimaryAccount'}
                                            name={"IsPrimaryAccount"}
                                            wmsSelector={this.selector + 'PrimaryAccount'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Primary_Account')}
                                            checked={this.state.currentCarrierObj.IsPrimaryAccount == true}
                                            isRounded={true}
                                        />
                                    </div>
                                </WmsCollapse>
                            )}
                        </div>
                    )}

                    {/* Fourth step */}
                    {this.state.upsAuthFlowCurrentStep == 0 && this.state.currentStep == 4 && (
                        <div className="connection-step-block">
                            <div className="image-section">
                                <img src={'assets/images/' + this.state.currentCarrierImgUrl} />
                            </div>
                            <WmsCollapse
                                id={'carrierInvoiceInformation'}
                                headerLabel={this.translate("Label_Invoice_Information")}
                                showCollapseText={false}
                                showCollapseIcon={false} >
                                <WmsDateTimePicker
                                    id='invoiceDate'
                                    name='InvoiceDate'
                                    label={this.translate('Label_Invoice_Date')}
                                    onChangeFunc={this.handleCarrierObjChange}
                                    value={this.state.currentCarrierObj.InvoiceDate} />
                                <div className="wms-invoice-block">
                                    <WmsInput
                                        id='invoiceNumber'
                                        inputName='InvoiceNumber'
                                        wmsSelector={this.selector + 'invoiceNumber'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Invoice_Number')}
                                        value={this.state.currentCarrierObj.InvoiceNumber}
                                        valueType="alphanumeric" />

                                    <WmsInput
                                        id='controlId'
                                        inputName='ControlId'
                                        wmsSelector={this.selector + 'controlId'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Control_Id')}
                                        value={this.state.currentCarrierObj.ControlId} />
                                    <WmsInput
                                        id='invoiceAmount'
                                        inputName='InvoiceAmount'
                                        wmsSelector={this.selector + 'invoiceAmount'}
                                        onChangeFunc={this.handleCarrierObjChange}
                                        label={this.translate('Label_Invoice_Total')}
                                        value={this.state.currentCarrierObj.InvoiceAmount}
                                        valueType="number"
                                        regularExp={/^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/} />
                                </div>
                            </WmsCollapse>

                            {this.state.selectedCarrier == "UPS" && (
                                <WmsCollapse
                                    id={'carrierSettings'}
                                    headerLabel={this.translate("Label_Settings")}
                                    showCollapseText={false}
                                    showCollapseIcon={false} >

                                    <div className="dropdown_section">
                                        <WmsDropdown
                                            id="pickupType"
                                            name="PickupType"
                                            label={this.translate('Label_Pickup_Type')}
                                            wmsSelector={this.selector + "PickupType"}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            value={this.state.currentCarrierObj.PickupType}
                                            options={this.state.pickupTypeOptions}
                                            valueField='value'
                                            textField='name'
                                            blankFirstOption={true}
                                        />
                                    </div>

                                    <div className="mail_section">
                                        <WmsDropdown
                                            id="mailInnovationsEndorsement"
                                            name="MailInnovationsEndorsement"
                                            label={this.translate('Label_Mail_Innovations_Endorsement')}
                                            wmsSelector={this.selector + "MailInnovationsEndorsement"}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            value={this.state.currentCarrierObj.MailInnovationsEndorsement}
                                            options={this.state.mailInnovationsEndorsementOptions}
                                            valueField='value'
                                            textField='name'
                                            blankFirstOption={true}
                                        />

                                        <WmsInput
                                            id='mailInnovationsCostCenter'
                                            inputName='MailInnovationsCostCenter'
                                            wmsSelector={this.selector + 'MailInnovationsCostCenter'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Mail_Innovations_Cost_Center')}
                                            value={this.state.currentCarrierObj.MailInnovationsCostCenter}
                                        />
                                    </div>

                                    <div className="mail_section">
                                        <WmsInput
                                            id='mailInnovationsCustomerId'
                                            inputName='MailInnovationsCustomerId'
                                            wmsSelector={this.selector + 'MailInnovationsCustomerId'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Mail_Innovations_Customer_Id')}
                                            value={this.state.currentCarrierObj.MailInnovationsCustomerId}
                                            regularExp={/(^[0-9]+$|^$)/}
                                            maxLength={6}
                                        />

                                        <WmsInput
                                            id='mailInnovationsCustomerGuid'
                                            inputName='MailInnovationsCustomerGuid'
                                            wmsSelector={this.selector + 'MailInnovationsCustomerGuid'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Mail_Innovations_Customer_Guid')}
                                            value={this.state.currentCarrierObj.MailInnovationsCustomerGuid}
                                        />
                                    </div>

                                    <div className="radio_section">
                                        <WmsCheckBox
                                            id={'useOrderNumberOnMailInnovationsLabels'}
                                            name={"UseOrderNumberOnMailInnovationsLabels"}
                                            wmsSelector={this.selector + 'UseOrderNumberOnMailInnovationsLabels'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Order_Number_On_Mail_Innovations_Labels')}
                                            checked={this.state.currentCarrierObj.UseOrderNumberOnMailInnovationsLabels == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'useConsolidationServices'}
                                            name={"UseConsolidationServices"}
                                            wmsSelector={this.selector + 'UseConsolidationServices'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Consolidation_Services')}
                                            checked={this.state.currentCarrierObj.UseConsolidationServices == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'useNegotiatedRates'}
                                            name={"UseNegotiatedRates"}
                                            wmsSelector={this.selector + 'UseNegotiatedRates'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Negotiated_Rates')}
                                            checked={this.state.currentCarrierObj.UseNegotiatedRates == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'useCarbonNeutralShippingProgram'}
                                            name={"UseCarbonNeutralShippingProgram"}
                                            wmsSelector={this.selector + 'UseCarbonNeutralShippingProgram'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Carbon_Neutral_Shipping_Program')}
                                            checked={this.state.currentCarrierObj.UseCarbonNeutralShippingProgram == true}
                                            isRounded={true}
                                        />


                                        <WmsCheckBox
                                            id={'useGroundFreightPricing'}
                                            name={"UseGroundFreightPricing"}
                                            wmsSelector={this.selector + 'UseGroundFreightPricing'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Use_Ground_Freight_Pricing')}
                                            checked={this.state.currentCarrierObj.UseGroundFreightPricing == true}
                                            isRounded={true}
                                        />

                                        <WmsCheckBox
                                            id={'isPrimaryAccount'}
                                            name={"IsPrimaryAccount"}
                                            wmsSelector={this.selector + 'PrimaryAccount'}
                                            onChangeFunc={this.handleCarrierObjChange}
                                            label={this.translate('Label_Primary_Account')}
                                            checked={this.state.currentCarrierObj.IsPrimaryAccount == true}
                                            isRounded={true}
                                        />
                                    </div>
                                </WmsCollapse>
                            )}
                        </div>
                    )}

                    {/* New AuthFlow */}
                    {this.state.upsAuthFlowCurrentStep == 1 && this.state.authUrl && (
                        <div className="connection-step-block ups-auth-flow-wrapper">
                            <h3>Authorize with {this.state.selectedCarrier}</h3>
                            <p>Do you have the {this.state.selectedCarrier} credentials for this account?</p>
                            <div className='radio-wrapper'>
                                <WmsRadio
                                    id="haveAuthoration"
                                    name="haveAuthoration"
                                    label={window.translate("Label_Yes")}
                                    wmsSelector={this.selector + "haveAuthoration"}
                                    onChangeFunc={this.onClickUpsAuthorization}
                                    checked={this.state.isHaveUpsAuthorization == true}
                                />
                                {this.state.isHaveUpsAuthorization == true && (
                                    <div className='alert-wrapper'>
                                        <div className='title'>
                                            <i className="fa fa-info-circle main-icon" aria-hidden="true"></i>
                                            <label>Have the {this.state.selectedCarrier} login and password ready</label>
                                        </div>
                                        <div className='description'>
                                            <p>You will need to enter them in a new browser pop-up</p>
                                        </div>
                                    </div>
                                )}
                                <WmsRadio
                                    id="notHaveAuthoration"
                                    name="notHaveAuthoration"
                                    label={window.translate("Ask_For_Authoriz")}
                                    wmsSelector={this.selector + "notHaveAuthoration"}
                                    onChangeFunc={this.onClickUpsAuthorization}
                                    checked={this.state.isHaveUpsAuthorization == false}
                                />
                                {this.state.isHaveUpsAuthorization == false && (
                                    <div className='alert-wrapper'>
                                        <div className='title'>
                                            <i className="fa fa-info-circle main-icon" aria-hidden="true"></i>
                                            <label>Please make sure they are ready to log in.</label>
                                        </div>
                                        <div className='description'>
                                            <p>When you click “Next”, we’ll create a login link that you can share with the {this.state.selectedCarrier} account owner. The link will be valid for 10 minutes. You can reset it if it expires.</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {this.state.upsAuthFlowCurrentStep == 2 && this.state.isHaveUpsAuthorization == false && this.state.authUrl && (
                        <div className="connection-step-block ups-auth-flow-wrapper">
                            <h3>Authorize with {this.state.selectedCarrier}</h3>
                            {this.state.showExpireLinkTimer && (
                                <div className={this.state.isAuthReset ? 'link-reset-alert' :'link-expire-alert'}>
                                    <div>
                                        {this.state.isResetLinkCalling && (
                                            <div className='alert-text-wrapper reseting-msg'>
                                                <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                                <p>Reseting the link...</p>
                                            </div>
                                        )}
                                        {this.state.isAuthReset && (
                                            <div className='alert-text-wrapper'>
                                                <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                                                <div className='linked-reset'>
                                                    <h4>The link has been reset.</h4>
                                                    <p>Please share the updated link with your customer.</p>
                                                </div>
                                            </div>
                                        )}
                                        {this.state.showExpiredLinkMsg == true && (
                                            <div className='alert-text-wrapper'>
                                                <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                <div>
                                                    <h4>The link has expired.</h4>
                                                    <p>If you’d like to try again, please reset it.</p>
                                                </div>
                                            </div>
                                        )}
                                        {this.state.showExpiredLinkMsg == false && this.state.isResetLinkCalling == false && this.state.isAuthReset == false && (
                                            <div className='alert-text-wrapper expiring-msg'>
                                                <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                <span>The link will expire in {this.state.time.m}:{this.state.time.s} </span>
                                            </div>
                                        )}
                                    </div>
                                    {!this.state.isAuthReset && (
                                        <div className='alert-btn-wrapper'>
                                            <WmsButton
                                                label={this.translate('Label_Reset_Link')}
                                                buttonType='orange'
                                                wmsSelector={this.selector + 'RestLink'}
                                                onClickFunc={this.resetLink}
                                                icon='fa-repeat' />
                                        </div>
                                    )}
                                </div>
                            )}
                            {((this.state.showExpiredLinkMsg == false && this.state.isResetLinkCalling == false) || this.state.isAuthReset) && (
                                <div>
                                    <p>Share these instructions with the {this.state.selectedCarrier} account owner:</p>
                                    <div className='connection-ups-wrapper'>
                                        <p>To connect your {this.state.selectedCarrier} account to your 3PL’s warehouse management system:</p>

                                        <li>
                                            <i className="fa fa-circle" aria-hidden="true"></i>
                                            <div className="auth-url-wrapper">Go to <a href={this.state.authUrl} target='_blank'>{this.state.authUrl}</a></div>
                                        </li>
                                        <li>
                                            <i className="fa fa-circle" aria-hidden="true"></i>
                                            <div>Log in with your {this.state.selectedCarrier} account</div>
                                        </li>

                                        <p>This link is valid for 10 minutes.</p>
                                    </div>
                                    <div className='copy-btn-wrapper'>
                                        <WmsButton
                                            label={this.translate('Label_Copy_Instructions')}
                                            wmsSelector={this.selector + 'CopyInstruction'}
                                            onClickFunc={this.copyInstructionToClipBoard}
                                            icon='fa fa-copy' />
                                        <WmsButton
                                            label={this.translate('Label_Copy_Link_Only')}
                                            wmsSelector={this.selector + 'CopyLinkOnly'}
                                            onClickFunc={this.copyLinkToClipBoard}
                                            parentClassName="copy-link-btn"
                                            icon='fa fa-link' />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {(
                        (this.state.upsAuthFlowCurrentStep == 2 && this.state.isHaveUpsAuthorization == true) ||
                        (this.state.upsAuthFlowCurrentStep == 3 && this.state.isHaveUpsAuthorization == false)
                    ) &&
                        this.state.authUrl && (
                        <div className="connection-step-block ups-auth-flow-wrapper">
                            <h3>Authorize with {this.state.selectedCarrier}</h3>
                            {this.state.isCarrierConnectionWorking == 'Yes' ? (
                                <div className='check-connection-success-alert'><i className="fa-regular fa-circle-check"></i> Your {this.state.selectedCarrier} connection is working!</div>
                            ) : (this.state.isCarrierConnectionWorking == 'No') ? (
                                <>
                                    <div className='check-connection-error-alert'>
                                        <h3><i className="fa-regular fa-hexagon-exclamation"></i> Unable to establish your {this.state.selectedCarrier} connection</h3>
                                        <p>Wait a few seconds and check again. if after a few attempts the connection is still not established, you may need to start over.</p>
                                    </div>
                                    <div className='check-connection-wrapper'>
                                        <WmsButton
                                            label={'Check ' + this.state.selectedCarrier + ' Connection'}
                                            wmsSelector={this.selector + 'CheckConnectionFinal'}
                                            onClickFunc={this.checkConnectionAuthorizedFinal}
                                            disabled={this.state.checkCarrierConnectionBtnLoader}
                                            icon='fa fa-check' />
                                    </div>
                                </>
                                ) : (
                                <div>
                                    {this.state.upsAuthFlowCurrentStep == 2 && this.state.isHaveUpsAuthorization == true && (
                                        <>
                                            {(this.state.checkCarrierConnectionBtnLoader === true) ? (
                                                <div className='check-connection-loading-alert'><i className="fa-solid fa-spinner-third fa-spin"></i> Checking connection....</div>
                                            ) : (
                                                <p className='popup-title'>If you have successfully logged into {this.state.selectedCarrier}, check your connection to make sure it's established:</p>
                                            )}
                                            <div className='check-connection-wrapper'>
                                                <WmsButton
                                                    label={'Check ' + this.state.selectedCarrier + ' Connection'}
                                                    wmsSelector={this.selector + 'CheckConnectionFinal'}
                                                    onClickFunc={this.checkConnectionAuthorizedFinal}
                                                    disabled={this.state.checkCarrierConnectionBtnLoader}
                                                    icon='fa fa-check' />
                                            </div>
                                            {!this.state.checkCarrierConnectionBtnLoader && (
                                                <>
                                                    <hr></hr>
                                                    <div className='check-connection-wrapper'>
                                                        <div className='popup-title'>Could not login or did not see the popup?</div>
                                                        <a onClick={this.tryAgainConnectionAuthorized}>Try again</a>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {(this.state.upsAuthFlowCurrentStep == 3 && this.state.isHaveUpsAuthorization == false && (
                                        <>
                                            {(this.state.checkCarrierConnectionBtnLoader === true) ? (
                                                <div className='check-connection-loading-alert'><i className="fa-solid fa-spinner-third fa-spin"></i> Checking connection....</div>
                                            ) : (
                                                <>
                                                    <li>Wait for the account owner to enter their {this.state.selectedCarrier} credentials.</li>
                                                    <li>Check the {this.state.selectedCarrier} connection to make sure everything is working.</li>
                                                </>
                                            )}
                                            <div className='check-connection-wrapper'>
                                                <WmsButton
                                                    label={'Check ' + this.state.selectedCarrier + ' Connection'}
                                                    wmsSelector={this.selector + 'CheckConnectionFinal'}
                                                    onClickFunc={this.checkConnectionAuthorizedFinal}
                                                    disabled={this.state.checkCarrierConnectionBtnLoader}
                                                    icon='fa fa-check' />
                                            </div>
                                        </>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="footer-btn-holder">

                    <WmsButton
                        label={this.translate('Label_Close')}
                        buttonType='orange'
                        wmsSelector={this.selector + 'exitNewConnection'}
                        onClickFunc={this.props.closeCarrierConnection}
                        icon='fa-times-circle-o' />
                    {this.props.sharedCarrierConnectionFlow == 'create' && this.state.isCarrierConnectionWorking != 'Yes' && (
                        <WmsButton
                            label={this.translate('Label_Previous')}
                            wmsSelector={this.selector + 'previous'}
                            onClickFunc={this.movePreviousStep}
                            icon='fa-caret-left'
                            disabled={this.state.currentStep == 1 && !this.state.isOpenPitneyBowesModel} />
                    )}
                    {!this.state.isAuthUrl && this.props.sharedCarrierConnectionFlow == 'create' && (
                        <WmsButton
                            label={
                                ( this.state.isOpenPitneyBowesModel ? this.translate('Label_Carrier_Account_Login') : (this.state.totalSteps == this.state.currentStep) ?
                                    this.translate('Label_Authorize_With') + this.state.selectedCarrier :
                                    this.translate('Label_Next')
                                )
                            }
                            wmsSelector={this.selector + 'next'}
                            onClickFunc={
                                ( this.state.isOpenPitneyBowesModel ? this.addPitneyBowesAccout : (this.state.totalSteps == this.state.currentStep) ?
                                    this.addCarrier :
                                    this.moveNextStep
                                )
                            }
                            parentClassName={this.state.currentStep == 2 && this.state.selectedCarrier == "PitneyBowesStd" && this.state.selectedProviderIndex == "pitneyBowes"}
                            loading={this.state.carrierConnectionBtnLoader}
                            disabled={
                                (
                                    this.state.currentStep == 1 && !this.state.isOpenPitneyBowesModel && (
                                        !this.state.selectedContentType ||
                                        (
                                            (
                                                this.state.selectedContentType == 'Warehouse Account' &&
                                                !this.state.selectedFacilityIndex
                                            ) || (
                                                this.state.selectedContentType == 'Customer Account' &&
                                                !this.state.selectedCustomerIndex
                                            )
                                        )
                                        ||
                                        !this.state.selectedCarrierIndex
                                        ||
                                        (this.isEnableProvider && !this.state.selectedProviderIndex)
                                    )
                                ) ||
                                (
                                    this.state.currentStep == 1 && this.state.isOpenPitneyBowesModel && (
                                        (
                                            this.state.selectedProviderIndex == 'pitneyBowes' && (
                                                !this.state.pitneyBowesUsername ||
                                                !this.state.pitneyBowesPassword
                                            )
                                        ) || (
                                            this.state.selectedProviderIndex == 'bukuShip' && (
                                                !this.state.providerUsername ||
                                                !this.state.providerOrganizationNumber ||
                                                !this.state.providerConnectToken
                                            )
                                        )
                                    )
                                ) ||
                                (
                                    this.state.currentStep == 2 && (
                                        (
                                            this.state.selectedCarrier == 'FedEx'
                                        ) &&
                                        (typeof this.state.currentCarrierObj.AgreeToEula == 'undefined' || this.state.currentCarrierObj.AgreeToEula == false)
                                    )
                                ) ||
                                (
                                    this.state.currentStep == 2 && (
                                        (
                                            this.state.selectedCarrier == "UPS"
                                        ) &&
                                        (
                                            !this.state.currentCarrierObj.Nickname ||
                                            !this.state.currentCarrierObj.AccountNumber ||
                                            !this.state.currentCarrierObj.AccountCountryCode ||
                                            !this.state.currentCarrierObj.AccountPostalCode
                                        )
                                    )
                                ) ||
                                (
                                    this.state.currentStep == 2 && (
                                        this.state.selectedCarrier != 'FedEx' &&
                                        this.state.selectedCarrier != "UPS" &&
                                        this.state.selectedCarrier != 'DHL eCommerce' &&
                                        this.state.selectedCarrier != 'DHL Express' &&
                                        this.state.selectedCarrier != 'Australia Post' &&
                                        this.state.selectedCarrier != 'APC' &&
                                        this.state.selectedCarrier != 'DHL Express Australia' &&
                                        this.state.selectedCarrier != 'Firstmile' &&
                                        this.state.selectedCarrier != 'Globegistics' &&
                                        this.state.selectedCarrier != 'RR Donnelley' &&
                                        this.state.selectedCarrier != 'Canada Post' &&
                                        this.state.selectedCarrier != 'OnTrac' &&
                                        this.state.selectedCarrier != 'SEKO' &&
                                        this.state.selectedCarrier != 'Amazon Buy' &&
                                        this.state.selectedCarrier != 'Canpar' &&
                                        this.state.selectedCarrier != 'Purolator' &&
                                        this.state.selectedCarrier != 'PitneyBowesStd' &&
                                        this.state.selectedCarrier != 'USPS' &&
                                        this.state.selectedCarrier != 'Landmark' &&
                                        this.state.selectedCarrier != 'Cirro E-Commerce' &&
                                        this.state.selectedCarrier != 'UPS Mail Innovations' &&
                                        this.state.selectedCarrier != 'ePost Global' &&
                                        this.state.selectedCarrier != 'Pitney Bowes Cross-Border' &&
                                        this.state.selectedCarrier != 'Stallion Express' &&
                                        this.state.selectedCarrier != 'FedEx SmartPost' &&
                                        this.state.selectedCarrier != 'UPS SurePost' &&
                                        this.state.selectedCarrier != 'Passport' &&
                                        this.state.selectedCarrier != 'Sendle' &&
                                        this.state.selectedCarrier != 'Tusk Logistics' &&
                                        this.state.selectedCarrier != 'Flexport' &&
                                        this.state.selectedCarrier != 'Lasership'
                                    ) &&
                                    (
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Passphrase ||
                                        !this.state.currentCarrierObj.Nickname
                                    )
                                ) ||
                                (
                                    this.state.currentStep == 2 && this.state.selectedCarrier == 'USPS' && (
                                        this.state.selectedProviderIndex == "Endicia" || this.state.selectedProviderIndex == "Stamps.com"
                                    ) &&
                                    (
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Passphrase ||
                                        !this.state.currentCarrierObj.Nickname
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'USPS' && this.state.selectedProviderIndex == 'pitneyBowes' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'USPS' && this.state.selectedProviderIndex == 'bukuShip' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.FirstName ||
                                        !this.state.currentCarrierObj.LastName ||
                                        !this.state.currentCarrierObj.Company ||
                                        !this.state.currentCarrierObj.Phone ||
                                        !this.state.currentCarrierObj.Email ||
                                        !this.state.currentCarrierObj.Address1 ||
                                        !this.state.currentCarrierObj.City ||
                                        !this.state.currentCarrierObj.State ||
                                        !this.state.currentCarrierObj.PostalCode ||
                                        !this.state.currentCarrierObj.CountryCode
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'DHL eCommerce' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.ClientId ||
                                        !this.state.currentCarrierObj.ApiSecret ||
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.PickupNumber ||
                                        !this.state.currentCarrierObj.DistributionCenter
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'DHL Express' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'Australia Post' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.ApiKey ||
                                        !this.state.currentCarrierObj.ApiSecret
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'APC' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.Username ||
                                        !this.state.currentCarrierObj.Passphrase
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'Canada Post' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.ApiKey ||
                                        !this.state.currentCarrierObj.ApiSecret
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'Purolator' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.Passphrase ||
                                        !this.state.currentCarrierObj.ApiKey
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'Firstmile' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.MailerId ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'SEKO' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccessKey
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'DHL Express Australia' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'RR Donnelley' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.Username ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'OnTrac' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) ||
                                (this.state.currentStep == 2 && this.state.selectedCarrier == 'Globegistics' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.Username ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Amazon Buy' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Password ||
                                        !this.state.currentCarrierObj.Email
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Canpar' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Username ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == "PitneyBowesStd" && this.state.selectedProviderIndex == "pitneyBowes" &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.accountNumber ||
                                        !this.state.currentCarrierObj.carrierFacilityId ||
                                        !this.state.currentCarrierObj.clientFacilityId ||
                                        !this.state.currentCarrierObj.nonDeliveryDefault
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Landmark' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.ClientId ||
                                        !this.state.currentCarrierObj.Username ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Cirro E-Commerce' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.ApiKey ||
                                        !this.state.currentCarrierObj.HubLocation ||
                                        !this.state.currentCarrierObj.AccountNumber
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'UPS Mail Innovations' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Username ||
                                        !this.state.currentCarrierObj.Password ||
                                        !this.state.currentCarrierObj.MailInnovationsCostCenter ||
                                        !this.state.currentCarrierObj.MailInnovationsEndorsement
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'ePost Global' && this.state.selectedProviderIndex == 'bukuShip' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.ApiToken
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'ePost Global' && this.state.selectedProviderIndex == 'shipEngine' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.Username ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Pitney Bowes Cross-Border' &&
                                    (
                                        this.state.pitneyBowesCrossBorderDisabledStatus
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Stallion Express' &&
                                    (
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.ApiKey
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'FedEx SmartPost' &&
                                    (
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.FirstName ||
                                        !this.state.currentCarrierObj.LastName ||
                                        !this.state.currentCarrierObj.Company ||
                                        !this.state.currentCarrierObj.Email ||
                                        !this.state.currentCarrierObj.ContactTitle ||
                                        !this.state.currentCarrierObj.Phone ||
                                        !this.state.currentCarrierObj.City ||
                                        !this.state.currentCarrierObj.State ||
                                        !this.state.currentCarrierObj.PostalCode ||
                                        !this.state.currentCarrierObj.CountryCode ||
                                        !this.state.currentCarrierObj.Address1 ||
                                        !this.state.currentCarrierObj.HubId ||
                                        !this.state.currentCarrierObj.ShippingAddress1 ||
                                        !this.state.currentCarrierObj.ShippingCity ||
                                        !this.state.currentCarrierObj.ShippingState ||
                                        !this.state.currentCarrierObj.ShippingPostalCode ||
                                        !this.state.currentCarrierObj.ShippingCountryCode
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'UPS SurePost' &&
                                    (
                                        !this.state.currentCarrierObj.AccountNumber ||
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.UserId ||
                                        !this.state.currentCarrierObj.Password
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Passport' &&
                                    (
                                        !this.state.currentCarrierObj.ApiKey ||
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.Company
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Sendle' &&
                                    (
                                        !this.state.currentCarrierObj.ApiKey ||
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.UserId
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Tusk Logistics' &&
                                    (
                                        !this.state.currentCarrierObj.ApiKey ||
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.AccountNumber
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Flexport' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.ApiToken ||
                                        !this.state.currentCarrierObj.InjectionLocation
                                    )
                                ) || (this.state.currentStep == 2 && this.state.selectedCarrier == 'Lasership' &&
                                    (
                                        !this.state.currentCarrierObj.Nickname ||
                                        !this.state.currentCarrierObj.WebServicesId ||
                                        !this.state.currentCarrierObj.WebServicesKey ||
                                        !this.state.currentCarrierObj.CustomerBranch ||
                                        !this.state.currentCarrierObj.Address1 ||
                                        !this.state.currentCarrierObj.City ||
                                        !this.state.currentCarrierObj.State ||
                                        !this.state.currentCarrierObj.Phone ||
                                        !this.state.currentCarrierObj.Email ||
                                        !this.state.currentCarrierObj.PostalCode ||
                                        !this.state.currentCarrierObj.CriticalPullTime ||
                                        !this.state.currentCarrierObj.CriticalEntryTime
                                    )
                                ) || (this.state.currentStep == 3 && this.state.selectedCarrier == 'FedEx' &&
                                        !this.state.currentCarrierObj.AccountNumber )
                            }
                            icon={this.state.isOpenPitneyBowesModel ? 'fa-sign-in' : 'fa-caret-right'} />

                    )}
                    {this.state.isAuthUrl && this.state.isCarrierConnectionWorking != 'Yes' && (

                        <WmsButton
                            label={this.state.upsAuthFlowCurrentStep > 0 ?
                                ((this.state.upsAuthFlowCurrentStep == 2 && this.state.isHaveUpsAuthorization == true) || (this.state.upsAuthFlowCurrentStep == 3 && this.state.isHaveUpsAuthorization == false)) ? this.translate('Label_Start_Over') : this.translate('Label_Next')
                                : 'Check ' + this.state.selectedCarrier + ' Connection'}
                            wmsSelector={this.selector + 'CheckConnectionAuthorized'}
                            onClickFunc={((this.state.upsAuthFlowCurrentStep == 2 && this.state.isHaveUpsAuthorization == true) || (this.state.upsAuthFlowCurrentStep == 3 && this.state.isHaveUpsAuthorization == false)) ? this.startOverConnectionAuthorize : this.checkConnectionAuthorized}
                            icon={this.state.upsAuthFlowCurrentStep > 0 ?
                                ((this.state.upsAuthFlowCurrentStep == 2 && this.state.isHaveUpsAuthorization == true) || (this.state.upsAuthFlowCurrentStep == 3 && this.state.isHaveUpsAuthorization == false)) ? 'fa-solid fa-backward' : 'fa-caret-right'
                                : "fa fa-check"}
                            loading={this.state.carrierConnectionBtnLoader}
                            disabled={this.state.isHaveUpsAuthorization == null || this.state.showExpiredLinkMsg}
                        />
                    )}
                    {this.props.sharedCarrierConnectionFlow == 'edit' && (
                        <WmsButton
                            label={this.translate('Label_Save')}
                            wmsSelector={this.selector + 'EditCarriersave'}
                            onClickFunc={this.updateCarrier}
                            icon="fa-floppy-o"
                            loading={this.state.carrierConnectionBtnLoader}
                        />
                    )}

                </div>
            </WmsModel>
        );
    }
}